module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorStringHelper", function() { return colorStringHelper; });
/* harmony export (immutable) */ __webpack_exports__["getXValuesByYear"] = getXValuesByYear;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeClassNameGroup", function() { return makeClassNameGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeClassNameLabels", function() { return makeClassNameLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeClassNamePoints", function() { return makeClassNamePoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyAndSortArray", function() { return copyAndSortArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPercentValue", function() { return isPercentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunc", function() { return isFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFromArray", function() { return removeFromArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfigValueWithStyle", function() { return getConfigValueWithStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindAppend", function() { return bindAppend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tooltipFormatDefault", function() { return tooltipFormatDefault; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(3);




var colorStringHelper = function colorStringHelper(color) {
  // Points to a def if the color string begins with DEF_ID_FLAG ('id:')
  if (color && color.slice(0, __WEBPACK_IMPORTED_MODULE_1__constants__["DEF_ID_FLAG"].length) === __WEBPACK_IMPORTED_MODULE_1__constants__["DEF_ID_FLAG"]) {
    color = 'url(#' + color.slice(__WEBPACK_IMPORTED_MODULE_1__constants__["DEF_ID_FLAG"].length) + ')';
  }
  return color;
};

function getXValuesByYear() {
  var values = [];
  var lastYear = void 0;
  this.dataSorted.x.forEach(function (x, i) {
    var thisYear = x.getFullYear();
    if (i === 0 || thisYear !== lastYear) {
      values.push(new Date(thisYear, 0, 1));
      lastYear = thisYear;
    }
  });
  return values;
}

var makeClassNameGroup = function makeClassNameGroup(seriesId) {
  return 'series-group--' + seriesId;
};
var makeClassNameLabels = function makeClassNameLabels(seriesId) {
  return 'series-labels--' + seriesId;
};
var makeClassNamePoints = function makeClassNamePoints(seriesId) {
  return 'series-points--' + seriesId;
};

var copyAndSortArray = function copyAndSortArray(data, attr) {
  return Array.prototype.slice.call(data).sort(function (a, b) {
    return attr ? a[attr] - b[attr] : a - b;
  });
};

var isPercentValue = function isPercentValue(value) {
  return typeof value === 'string' && value[value.length - 1] === '%';
};
var isObject = function isObject(value) {
  return value && value.constructor === Object;
};
var isArray = function isArray(value) {
  return value && value.constructor === Array;
};
var isNumber = function isNumber(value) {
  return typeof value === 'number';
};
var isFunc = function isFunc(value) {
  return typeof value === 'function';
};

var _removeSingleItemFromArray = function _removeSingleItemFromArray(arr, value) {
  var pos = arr.indexOf(value);
  return arr.slice(0, pos).concat(arr.slice(pos + 1, arr.length));
};

var removeFromArray = function removeFromArray(arr, value) {
  if (!isArray(value)) {
    return _removeSingleItemFromArray(arr, value);
  }
  value.forEach(function (v) {
    arr = _removeSingleItemFromArray(arr, v);
  });
  return arr;
};

var getConfigValueWithStyle = function getConfigValueWithStyle(config, attr) {
  if (config.hasOwnProperty('style') && config.style.hasOwnProperty(attr)) {
    return config.style[attr];
  } else {
    return config[attr];
  }
};

// Same effect as Function.prototype.bind except args are appended rather than prepended
var bindAppend = function bindAppend(func, context, args) {
  return function () {
    return func.apply(context, [].slice.call(arguments).concat(args));
  };
};

var tooltipFormatDefault = function tooltipFormatDefault(v) {
  return v && v instanceof Date ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__["timeFormat"])('%Y-%m-%d')(v) : v.toString();
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("d3-selection");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FONT_FAMILY", function() { return FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEF_ID_FLAG", function() { return DEF_ID_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAR_CHART_CLASSNAME_BAR", function() { return BAR_CHART_CLASSNAME_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAR_CHART_CLASSNAME_GROUP", function() { return BAR_CHART_CLASSNAME_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAR_CHART_CLASSNAME_LABEL", function() { return BAR_CHART_CLASSNAME_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLOTLINE_CLASSNAME", function() { return PLOTLINE_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLOTLINE_DASH_STYLES", function() { return PLOTLINE_DASH_STYLES; });
var FONT_FAMILY = 'Avenir W01,Avenir,Helvetica,sans-serif';
var DEF_ID_FLAG = 'id:';
var BAR_CHART_CLASSNAME_BAR = 'cdj-bar-chart-bar';
var BAR_CHART_CLASSNAME_GROUP = 'cdj-bar-chart-group';
var BAR_CHART_CLASSNAME_LABEL = 'cdj-bar-chart-label';
var PLOTLINE_CLASSNAME = 'plotline';
var PLOTLINE_DASH_STYLES = {
  solid: function solid(p) {
    return undefined;
  },
  dashed: function dashed(p) {
    return p.width * 5;
  },
  dotted: function dotted(p) {
    return p.width;
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(42);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineOrange", function() { return lineOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineGrey", function() { return lineGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillOrange", function() { return fillOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textDark", function() { return textDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderLight", function() { return borderLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearOrange", function() { return gradientLinearOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearGrey", function() { return gradientLinearGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearForecast3", function() { return gradientLinearForecast3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearForecast2", function() { return gradientLinearForecast2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearForecast1", function() { return gradientLinearForecast1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientLinearForecastPast", function() { return gradientLinearForecastPast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradients", function() { return gradients; });
// COLORS
var lineOrange = '#FEB913';
var lineGrey = '#E5E5E5';
var fillOrange = '#FDCC7F';
var textDark = '#4A4A4A';
var borderLight = '#EAEAEA';

var colors = {
  lineOrange: lineOrange,
  fillOrange: fillOrange,
  textDark: textDark,
  borderLight: borderLight
};

// GRADIENTS
var gradientLinearOrange = {
  type: 'linearGradient',
  id: 'gradientLinearOrange',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: '#FAD961',
    opacity: 1
  }, {
    offset: '100%',
    color: '#FFB854',
    opacity: 1
  }]
};

var gradientLinearGrey = {
  type: 'linearGradient',
  id: 'gradientLinearGrey',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: '#EBEBEB', // Matches spec w/ 50% opacity
    opacity: 0.5
  }, {
    offset: '100%',
    color: '#D1D1D1', // Matches spec w/ 50% opacity
    opacity: 0.5
  }]
};

var gradientLinearForecast3 = {
  type: 'linearGradient',
  id: 'gradientLinearForecast3',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: 'rgb(250, 217, 97)',
    opacity: 0.95
  }, {
    offset: '100%',
    color: 'rgb(255, 184, 84)',
    opacity: 0.95
  }]
};

var gradientLinearForecast2 = {
  type: 'linearGradient',
  id: 'gradientLinearForecast2',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: 'rgb(250, 217, 97)',
    opacity: 0.75
  }, {
    offset: '100%',
    color: 'rgb(255, 184, 84)',
    opacity: 0.75
  }]
};

var gradientLinearForecast1 = {
  type: 'linearGradient',
  id: 'gradientLinearForecast1',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: 'rgb(250, 217, 97)',
    opacity: 0.45
  }, {
    offset: '100%',
    color: 'rgb(255, 184, 84)',
    opacity: 0.45
  }]
};

var gradientLinearForecastPast = {
  type: 'linearGradient',
  id: 'gradientLinearForecastPast',
  coords: {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  },
  stops: [{
    offset: '0%',
    color: 'rgb(250, 217, 97)',
    opacity: 0.35
  }, {
    offset: '100%',
    color: 'rgb(255, 184, 84)',
    opacity: 0.35
  }]
};

var gradients = {
  gradientLinearOrange: gradientLinearOrange,
  gradientLinearGrey: gradientLinearGrey,
  gradientLinearForecast3: gradientLinearForecast3,
  gradientLinearForecast2: gradientLinearForecast2,
  gradientLinearForecast1: gradientLinearForecast1,
  gradientLinearForecastPast: gradientLinearForecastPast
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultsDeep;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return plotlineDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildChartConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_ease__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_ease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_ease__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_transition__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ChartTooltipShared__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ChartTooltipSingular__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ChartLegendVertical__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_palette__ = __webpack_require__(7);















var globalDefaults = {
  chart: {
    className: undefined,
    height: '100%',
    width: '100%',
    margin: {
      top: 60,
      right: 30,
      bottom: 90,
      left: 50
    }
  },
  legend: {
    enabled: false,
    component: __WEBPACK_IMPORTED_MODULE_8_components_ChartLegendVertical__["a" /* default */],
    type: 'vertical',
    className: undefined
  },
  tooltip: {
    shared: {
      enabled: false,
      className: undefined,
      zIndex: 2,
      component: __WEBPACK_IMPORTED_MODULE_6_components_ChartTooltipShared__["a" /* default */],
      formatX: __WEBPACK_IMPORTED_MODULE_5_utils__["tooltipFormatDefault"],
      formatY: __WEBPACK_IMPORTED_MODULE_5_utils__["tooltipFormatDefault"],
      timeoutHide: 1000,
      line: {
        className: undefined,
        width: 1,
        color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].borderLight
      }
    },
    singular: {
      // Currently only supported by 'scatter' series
      className: undefined,
      enabled: false,
      timeoutHide: 1000,
      component: __WEBPACK_IMPORTED_MODULE_7_components_ChartTooltipSingular__["a" /* default */],
      formatX: __WEBPACK_IMPORTED_MODULE_5_utils__["tooltipFormatDefault"],
      formatY: __WEBPACK_IMPORTED_MODULE_5_utils__["tooltipFormatDefault"]
    }
  },
  xAxis: {
    className: undefined,
    zIndex: 0,
    ticks: {
      className: undefined,
      count: undefined,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].borderLight,
      length: 6,
      position: 'aligned',
      label: {
        // adjustmentMethod can be "wrap", "rotate", or false (automagically chooses best one)
        adjustmentMethod: undefined,
        className: undefined,
        color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].textDark,
        adjustY: 13,
        adjustX: 0,
        fontWeight: 'normal',
        fontSize: 12
      }
    },
    line: {
      className: undefined,
      width: 1,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].borderLight
    },
    scale: {
      floor: 'min',
      ceil: 'max',
      paddingFloor: 0,
      paddingCeil: 0,
      paddingType: 'unit'
      // paddingType options
      //   unit = defined in axis units
      //   pct-min = % of dataMin
      //   pct-max = % of dataMax
      //   pct-range = % of dataMax - dataMin
      //   px = screen pixels
    },
    label: {
      className: undefined,
      enabled: false,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].textDark,
      adjustY: function adjustY() {
        return this.adjustedXaXisTickLabelHeight || 50;
      },
      adjustX: 0,
      fontSize: 14,
      fontWeight: 'bold',
      x: function x(d, label) {
        return this.chartWidth / 2;
      }
    }
  },
  yAxis: {
    className: undefined,
    zIndex: 1,
    gridLines: {
      className: undefined,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].borderLight
    },
    line: {
      className: undefined,
      width: 0,
      color: 'transparent'
    },
    ticks: {
      className: undefined,
      count: 5,
      color: 'transparent',
      label: {
        className: undefined,
        color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].textDark,
        adjustY: 0,
        adjustX: 0,
        fontWeight: 'normal',
        fontSize: 12
      }
    },
    scale: {
      type: 'linear',
      floor: 'min',
      ceil: 'max',
      paddingFloor: 0,
      paddingCeil: 0
    },
    label: {
      className: undefined,
      enabled: false,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].textDark,
      adjustX: -40,
      adjustY: 0,
      fontSize: 14,
      fontWeight: 'bold',
      y: function y(d, label) {
        var labelDimensions = label.node().getBBox();
        return -this.chartHeight / 2 + labelDimensions.width / 2;
      }
    }
  }
};

var xAxisTime = {
  ticks: {
    label: {
      format: Object(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__["timeFormat"])('%Y-%m-%d')
    }
  },
  scale: {
    type: 'time',
    paddingType: 'pct-range',
    niceScale: true
  }
};

var xAxisBar = {
  ticks: {
    label: {
      format: function format(x) {
        return x.toString();
      }
    }
  },
  scale: {
    type: 'band',
    // Padding between bands (band scale only)
    padding: 0.1,
    align: 0.5
  }
};

var yAxisBar = {
  scale: {
    floor: 0
  }
};

var seriesDefaults = {
  bar: {
    borderRadius: [0, 0],
    className: undefined,
    zIndex: 1,
    opacity: 1,
    animation: {
      delay: function delay(d, i) {
        return i * 50;
      },
      ease: __WEBPACK_IMPORTED_MODULE_1_d3_ease__["easeLinear"],
      duration: 500
    },
    tooltip: {
      className: undefined,
      enabled: false,
      type: 'singular',
      adjustX: 0,
      adjustY: -10
    },
    label: {
      className: undefined,
      adjustX: 0,
      adjustY: -10,
      fontSize: 12,
      anchor: 'middle',
      format: function format(d) {
        return d.y;
      },
      enabled: true
    },
    fill: '' + __WEBPACK_IMPORTED_MODULE_4__constants__["DEF_ID_FLAG"] + __WEBPACK_IMPORTED_MODULE_9_palette__["gradientLinearOrange"].id,
    stroke: {
      className: undefined,
      width: 2,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].lineOrange
    },
    onMouseOver: function onMouseOver() {},
    onMouseOut: function onMouseOut() {},
    legend: {
      label: '',
      marker: {
        width: 20
      }
    }
  },
  line: {
    className: undefined,
    zIndex: 1,
    opacity: 1,
    animation: {
      delay: function delay(d, i) {
        return i * 50;
      },
      ease: __WEBPACK_IMPORTED_MODULE_1_d3_ease__["easeLinear"],
      duration: 500
    },
    tooltip: {
      className: undefined,
      type: 'shared',
      adjustX: 0,
      adjustY: 0
    },
    label: {
      className: undefined,
      enabled: false,
      adjustY: 0,
      adjustX: 0,
      anchor: 'middle',
      format: function format(d) {
        return d.y;
      }
    },
    stroke: {
      className: undefined,
      width: 3,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].lineOrange
    },
    legend: {
      label: '',
      marker: {
        width: 20
      }
    }
  },
  area: {
    className: undefined,
    zIndex: 1,
    opacity: 1,
    animation: {
      delay: function delay(d, i) {
        return i * 50;
      },
      ease: __WEBPACK_IMPORTED_MODULE_1_d3_ease__["easeLinear"],
      duration: 500
    },
    tooltip: {
      className: undefined,
      type: 'shared',
      adjustX: 0,
      adjustY: 0
    },
    label: {
      className: undefined,
      enabled: false,
      adjustY: 0,
      adjustX: 0,
      anchor: 'middle',
      format: function format(d) {
        return d.y;
      }
    },
    stroke: {
      enabled: false,
      width: 1
    },
    fill: '' + __WEBPACK_IMPORTED_MODULE_4__constants__["DEF_ID_FLAG"] + __WEBPACK_IMPORTED_MODULE_9_palette__["gradientLinearOrange"].id,
    legend: {
      label: '',
      marker: {
        width: 20
      }
    }
  },
  scatter: {
    className: undefined,
    zIndex: 1,
    opacity: 1,
    animation: {
      delay: function delay(d, i) {
        return i * 50;
      },
      ease: __WEBPACK_IMPORTED_MODULE_1_d3_ease__["easeLinear"],
      duration: 500
    },
    tooltip: {
      className: undefined,
      type: 'singular',
      adjustY: -18,
      adjustX: 4
    },
    stroke: {
      className: undefined,
      enabled: true,
      width: 2,
      color: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].lineOrange
    },
    label: {
      className: undefined,
      enabled: false,
      adjustY: 0,
      adjustX: 0,
      anchor: 'middle',
      format: function format(d) {
        return d.y;
      }
    },
    fill: __WEBPACK_IMPORTED_MODULE_9_palette__["colors"].fillOrange,
    radius: 5,
    adjustX: 0,
    adjustY: 0,
    onMouseOver: function onMouseOver(d, e) {
      Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(e.target).transition().duration(500).attr('r', 8);
    },
    onMouseOut: function onMouseOut(d, e) {
      Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(e.target).transition().duration(500).attr('r', 5);
    },
    // pointWidth and pointHeight are only used for scatter plots with image points
    pointWidth: 25,
    pointHeight: 25,
    // Pass in svgFragment for scatter points. If you also use an image this svg will be placed over it.
    svgFragment: undefined,
    adjustSvgFragmentX: 0,
    adjustSvgFragmentY: 0,
    type: 'scatter',
    legend: {
      label: '',
      marker: {
        width: 20
      }
    }
  }
};

var globalOverridesByType = {
  bar: {
    xAxis: xAxisBar,
    yAxis: yAxisBar,
    tooltip: {
      singular: {
        enabled: false
      }
    },
    defs: {
      gradient: new Array(__WEBPACK_IMPORTED_MODULE_9_palette__["gradientLinearOrange"])
    }
  },
  scatter: {
    xAxis: xAxisTime,
    tooltip: {
      singular: {
        enabled: true
      }
    }
  },
  area: {
    xAxis: xAxisTime,
    tooltip: {
      shared: {
        enabled: true
      }
    },
    defs: {
      gradient: new Array(__WEBPACK_IMPORTED_MODULE_9_palette__["gradientLinearOrange"])
    }
  },
  line: {
    xAxis: xAxisTime,
    tooltip: {
      shared: {
        enabled: true
      }
    }
  }
};

function defaultsDeep(destination, source) {
  var _loop = function _loop(attr) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isObject"])(source[attr]) && destination[attr] && !Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(destination[attr])) {
      destination[attr] = defaultsDeep(destination[attr] || {}, source[attr]);
    } else if (!destination.hasOwnProperty(attr)) {
      destination[attr] = source[attr];
    } else if (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(source[attr] && Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(destination[attr]))) {
      destination[attr] = destination[attr].concat(source[attr]);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(destination[attr]) && Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isObject"])(destination[attr][0]) && !Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(source[attr])) {
      // Apply defaults to all items in the array (axis labels)
      destination[attr].map(function (a) {
        return defaultsDeep(a, source[attr]);
      });
    }
  };

  for (var attr in source) {
    _loop(attr);
  }
  return destination;
}

var plotlineDefaults = {
  color: '#4A4A4A',
  width: 2,
  value: undefined,
  zIndex: 0,
  label: {
    enabled: false,
    format: function format(d) {
      return d.value;
    },
    fontSize: 12,
    adjustX: -5,
    adjustY: -5
  }
};

var buildChartConfig = function buildChartConfig(options) {
  // NOTE: This will have to change if/when we support bar series and other series types on the same chart
  //       This may also cause some issues if global overrides for line/area/scatter series differ
  var globalOverrides = {};
  // Apply series defaults
  if (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isObject"])(options.series)) {
    options.series = defaultsDeep(options.series, seriesDefaults[options.series.type]);
    // Update globalOverrides for series type
    globalOverrides = defaultsDeep(globalOverrides, globalOverridesByType[options.series.type]);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5_utils__["isArray"])(options.series)) {
    options.series.forEach(function (series, i) {
      options.series[i] = defaultsDeep(series, seriesDefaults[series.type]);
      // Update globalOverrides for series type
      globalOverrides = defaultsDeep(globalOverrides, globalOverridesByType[series.type]);
    });
  }
  return defaultsDeep(options, defaultsDeep(globalOverrides, globalDefaults));
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("d3-time-format");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("d3-scale");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("d3-array");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("d3-interpolate-path");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("d3-shape");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("d3-transition");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("d3-axis");

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ChartTooltipShared = function (_Component) {
  _inherits(ChartTooltipShared, _Component);

  function ChartTooltipShared() {
    _classCallCheck(this, ChartTooltipShared);

    return _possibleConstructorReturn(this, (ChartTooltipShared.__proto__ || Object.getPrototypeOf(ChartTooltipShared)).apply(this, arguments));
  }

  _createClass(ChartTooltipShared, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$tooltipConfig = _props.tooltipConfig,
          tooltipConfig = _props$tooltipConfig === undefined ? {} : _props$tooltipConfig,
          className = _props.className,
          points = _props.points,
          position = _props.position,
          attach = _props.attach;

      if (!points || !points.length) {
        return null;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_2_utils__["isNumber"])(position.top)) {
        position.top = position.top + 'px';
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_2_utils__["isNumber"])(position.left)) {
        position.left = position.left + 'px';
      }
      var formatX = tooltipConfig.formatX,
          formatY = tooltipConfig.formatY,
          format = tooltipConfig.format;

      var attachClass = attach === 'right' ? __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default.a.TooltipAttachRight : __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default.a.TooltipAttachLeft;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default.a.Tooltip, attachClass, className), style: position },
        typeof format === 'function' ? format(points) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          points && points.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default.a.TooltipX },
            points[0].label ? points[0].label : formatX(points[0].x)
          ),
          points.map(function (p, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: 'tippoint-' + i, className: __WEBPACK_IMPORTED_MODULE_3_css_modules_ChartTooltipShared_css_module_css___default.a.TooltipY },
              formatY(p.y)
            );
          })
        )
      );
    }
  }]);

  return ChartTooltipShared;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ChartTooltipShared);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartTooltipPosition__ = __webpack_require__(19);






var ChartTooltipSingular = __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (props, tooltipElementRef) {
  var className = props.className,
      point = props.point,
      position = props.position,
      shiftAmount = props.shiftAmount,
      tooltipConfig = props.tooltipConfig;
  var formatY = tooltipConfig.formatY,
      formatX = tooltipConfig.formatX;


  return !point ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css___default.a.Tooltip, className),
      style: {
        transform: 'translate(calc(-50% + ' + shiftAmount + 'px), -100%)',
        left: position.left,
        top: position.top
      },
      ref: tooltipElementRef },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css___default.a.TooltipContent },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css___default.a.InfoRow },
        point.label ? point.label : formatX(point.x)
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        formatY(point.y)
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_css_modules_ChartTooltipSingular_css_module_css___default.a.TooltipArrow, style: { left: 'calc(50% - 15px - ' + shiftAmount + 'px)' } })
    )
  );
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__ChartTooltipPosition__["a" /* default */])(ChartTooltipSingular));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global HTMLElement */


/* harmony default export */ __webpack_exports__["a"] = (function (TooltipComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(ChartTooltipPosition, _Component);

    function ChartTooltipPosition(props) {
      _classCallCheck(this, ChartTooltipPosition);

      var _this = _possibleConstructorReturn(this, (ChartTooltipPosition.__proto__ || Object.getPrototypeOf(ChartTooltipPosition)).call(this, props));

      _this.getShift = function (tooltipElement) {
        var marginFromEdge = _this.props.marginFromEdge;

        var prevShiftAmount = _this.state.shiftAmount;

        if (tooltipElement === null) {
          return 0;
        }

        var _tooltipElement$getBo = tooltipElement.getBoundingClientRect(),
            left = _tooltipElement$getBo.left,
            right = _tooltipElement$getBo.right;

        if (left < 0) {
          return Math.abs(left) + marginFromEdge + prevShiftAmount;
        } else if (right > window.innerWidth) {
          return -(right - window.innerWidth + marginFromEdge) + prevShiftAmount;
        } else {
          return 0;
        }
      };

      _this.checkPositioningAndDisplay = function () {
        var tooltipElement = _this.tooltipElementRef.current;
        var shiftAmount = 0;

        if (tooltipElement) {
          if (!(tooltipElement instanceof HTMLElement)) {
            return;
          }
          shiftAmount = _this.getShift(tooltipElement);
        }

        _this.setState({ shiftAmount: shiftAmount });
      };

      _this.tooltipElementRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
      _this.state = {
        shiftAmount: 0
      };
      return _this;
    }

    _createClass(ChartTooltipPosition, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.checkPositioningAndDisplay();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var position = prevProps.position;
        var left = position.left;

        if (left !== this.props.position.left) {
          this.checkPositioningAndDisplay();
        }
      }

      /**
       * Shift the tooltip to be completely within the viewport if it's partially offscreen
       * By the time that we shift the tooltip it's already been fit to be narrow enough
       * to fit within the viewport
       */

    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TooltipComponent, _extends({ ref: this.tooltipElementRef, shiftAmount: this.state.shiftAmount }, this.props));
      }
    }]);

    return ChartTooltipPosition;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
    marginFromEdge: 20
  }, _temp;
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_palette__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css__);







var LegendItem = function LegendItem(_ref) {
  var series = _ref.series;

  if (series.legend) {
    var _series$legend = series.legend,
        _series$legend$label = _series$legend.label,
        label = _series$legend$label === undefined ? '' : _series$legend$label,
        _series$legend$color = _series$legend.color,
        color = _series$legend$color === undefined ? series.fill || series.stroke.color || __WEBPACK_IMPORTED_MODULE_3_palette__["textDark"] : _series$legend$color,
        stroke = _series$legend.stroke;

    var markerStyle = {
      backgroundColor: color,
      border: stroke ? (stroke.width || 1) + 'px solid ' + (stroke.color || color) : 'none'
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.Series, title: label || '' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.SeriesMarker, style: markerStyle }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.SeriesLabel },
        label || ''
      )
    );
  }
  return null;
};

var ChartLegendVertical = function ChartLegendVertical(_ref2) {
  var className = _ref2.className,
      series = _ref2.series,
      legendConfig = _ref2.legendConfig;
  var title = legendConfig.title;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.Component, className) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h5',
      { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.Title },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendVertical_css_module_css___default.a.Items },
      Object(__WEBPACK_IMPORTED_MODULE_2_utils__["isObject"])(series) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendItem, { series: series }) : series.map(function (s, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendItem, { key: 'legend-item--' + (s.id || s.label || i), series: s });
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ChartLegendVertical);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Chart__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Chart", function() { return __WEBPACK_IMPORTED_MODULE_0_components_Chart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ChartLegendHorizontal__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartLegendHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_1_components_ChartLegendHorizontal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ChartLegendVertical__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartLegendVertical", function() { return __WEBPACK_IMPORTED_MODULE_2_components_ChartLegendVertical__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ChartTooltipShared__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartTooltipShared", function() { return __WEBPACK_IMPORTED_MODULE_3_components_ChartTooltipShared__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ChartTooltipSingular__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartTooltipSingular", function() { return __WEBPACK_IMPORTED_MODULE_4_components_ChartTooltipSingular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ChartTooltipPosition__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChartTooltipPosition", function() { return __WEBPACK_IMPORTED_MODULE_5_components_ChartTooltipPosition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(0);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "chartUtils", function() { return __WEBPACK_IMPORTED_MODULE_6_utils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_config__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buildChartConfig", function() { return __WEBPACK_IMPORTED_MODULE_7_chart_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants__ = __webpack_require__(3);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_8_constants__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_palette__ = __webpack_require__(7);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return __WEBPACK_IMPORTED_MODULE_9_palette__; });
// Components






// Utils




// Constants





/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_methods__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chart_config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Chart = function (_React$PureComponent) {
  _inherits(Chart, _React$PureComponent);

  function Chart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Chart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chart.__proto__ || Object.getPrototypeOf(Chart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tooltipSingularPoint: null,
      tooltipSingularPosition: null,
      tooltipSharedPoints: null,
      tooltipSharedPosition: null,
      tooltipSharedAttach: 'right',
      Legend: null,
      legendType: null
    }, _this.init = false, _this.isResponsive = false, _this.isResizing = false, _this.defsIds = {}, _this.updateOnResize = false, _this.encodedSvgs = {}, _this.resizeChartAnimationFrame = null, _this.layers = [], _this.chart = null, _this.defs = null, _this.series = {}, _this.plotlines = {}, _this.seriesDataId = {}, _this.seriesGroups = {}, _this.seriesTooltip = {}, _this.y = null, _this.yPrev = null, _this.x = null, _this.xPrev = null, _this.yAxis = null, _this.xAxis = null, _this.groupScales = null, _this.groupScalesPrev = null, _this.hideTooltipSingularTimeout = null, _this.hideTooltipSharedTimeout = null, _this.adjustedXaXisTickLabelHeight = null, _this.xAxisApi = null, _this.yAxisApi = null, _this.xAxisTickLabelAdjustmentMethod = null, _this.data = {
      x: null,
      y: null
      // All x and y values across all series sorted
    }, _this.dataSorted = {
      x: null,
      y: null
      // Max value for x and y across all series
    }, _this.dataMax = {
      x: null,
      y: null
      // Min value for x and y across all series
    }, _this.dataMin = {
      x: null,
      y: null
      // Sorted data arrays keyed by series id
    }, _this.dataSeriesSorted = {}, _this.componentWillUnmount = function () {
      if (_this.isResponsive) {
        window.removeEventListener('resize', _this.handleResize);
      }
      window.cancelAnimationFrame(_this.resizeChartAnimationFrame);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // All x and y values across all series


  _createClass(Chart, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // This allows us to keep this file small.
      // The class methods are broken up into multiple files to
      // improve maintainability
      for (var f in __WEBPACK_IMPORTED_MODULE_3__chart_methods__) {
        this[f] = __WEBPACK_IMPORTED_MODULE_3__chart_methods__[f].bind(this);
      }

      // Now that the chart methods have been properly bound, setup the mappings that are needed

      // These methods are defined in chart-methods/scales.js
      this.scaleTypes = {
        band: this.buildScaleBand,
        time: this.buildScaleTime,
        linear: this.buildScaleLinear
      };

      // These methods are defined in chart-methods/series-[x].js
      this.addSeries = {
        bar: this.addSeriesBar,
        line: this.addSeriesLine,
        area: this.addSeriesArea,
        scatter: this.addSeriesScatter
      };

      // These methods are defined in chart-methods/defs.js
      this.addDef = {
        gradient: this.addGradientDef
      };

      // These methods are defined in chart-methods/x-axis.js
      this.labelAdjustmentMethods = _defineProperty({
        rotate: this.rotateLabels,
        wrap: this.wrapLabels
      }, false, this.unadjustLabels);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.chartConfig = Object(__WEBPACK_IMPORTED_MODULE_4_chart_config__["a" /* buildChartConfig */])(this.props.chartConfig);
      this.initChart();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.chartConfigPrev = this.chartConfig;
      this.chartConfig = Object(__WEBPACK_IMPORTED_MODULE_4_chart_config__["a" /* buildChartConfig */])(nextProps.chartConfig);
      this.updateChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.legendType !== prevState.legendType) {}
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style;
      var _state = this.state,
          tooltipSingularPoint = _state.tooltipSingularPoint,
          tooltipSingularPosition = _state.tooltipSingularPosition,
          tooltipSharedPoints = _state.tooltipSharedPoints,
          tooltipSharedPosition = _state.tooltipSharedPosition,
          tooltipSharedAttach = _state.tooltipSharedAttach,
          Legend = _state.Legend,
          legendType = _state.legendType;

      var TooltipShared = this.tooltipShared ? this.tooltipShared : function () {
        return null;
      };
      var TooltipSingular = this.tooltipSingular ? this.tooltipSingular : function () {
        return null;
      };
      var legendClass = 'legend-' + legendType;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: style, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css___default.a.Component, className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css___default.a.ChartContainer + ' ' + __WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css___default.a[legendClass] },
          tooltipSingularPoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TooltipSingular, {
            chart: this,
            className: this.optionHelperCall(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.tooltipSingularConfig, 'className')),
            position: tooltipSingularPosition,
            tooltipConfig: this.tooltipSingularConfig,
            point: tooltipSingularPoint
          }),
          TooltipShared && tooltipSharedPoints && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TooltipShared, {
            chart: this,
            className: this.optionHelperCall(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.tooltipSharedConfig, 'className')),
            tooltipConfig: this.tooltipSharedConfig,
            points: tooltipSharedPoints,
            position: tooltipSharedPosition,
            attach: tooltipSharedAttach
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', { className: __WEBPACK_IMPORTED_MODULE_5_css_modules_Chart_css_module_css___default.a.Chart, ref: function ref(node) {
              _this2.node = node;
            } })
        ),
        Legend && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Legend, {
          className: this.optionHelperCall(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartConfig, ['legend', 'className'])),
          series: this.chartConfig.series,
          legendConfig: this.chartConfig.legend
        })
      );
    }
  }]);

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Chart.defaultProps = {
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Chart);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defs__ = __webpack_require__(25);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createDefs", function() { return __WEBPACK_IMPORTED_MODULE_0__defs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addGradientDef", function() { return __WEBPACK_IMPORTED_MODULE_0__defs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instance_utils__ = __webpack_require__(26);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "optionHelper", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "optionHelperCall", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "colorHelper", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "percentOfParentSize", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "styleLabels", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "styleLabelsGroup", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "applyConfigForSeriesGroup", function() { return __WEBPACK_IMPORTED_MODULE_1__instance_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__legend__ = __webpack_require__(27);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initLegend", function() { return __WEBPACK_IMPORTED_MODULE_2__legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle__ = __webpack_require__(28);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initChart", function() { return __WEBPACK_IMPORTED_MODULE_3__lifecycle__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateChart", function() { return __WEBPACK_IMPORTED_MODULE_3__lifecycle__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shouldChartUpdate", function() { return __WEBPACK_IMPORTED_MODULE_3__lifecycle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scales__ = __webpack_require__(29);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buildScaleBand", function() { return __WEBPACK_IMPORTED_MODULE_4__scales__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buildScaleTime", function() { return __WEBPACK_IMPORTED_MODULE_4__scales__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buildScaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_4__scales__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateScales", function() { return __WEBPACK_IMPORTED_MODULE_4__scales__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scaleHelper", function() { return __WEBPACK_IMPORTED_MODULE_4__scales__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__series__ = __webpack_require__(30);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateSeries", function() { return __WEBPACK_IMPORTED_MODULE_5__series__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeSeries", function() { return __WEBPACK_IMPORTED_MODULE_5__series__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeAllSeries", function() { return __WEBPACK_IMPORTED_MODULE_5__series__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shouldUpdateSeries", function() { return __WEBPACK_IMPORTED_MODULE_5__series__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__series_area__ = __webpack_require__(31);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addSeriesArea", function() { return __WEBPACK_IMPORTED_MODULE_6__series_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__series_bar__ = __webpack_require__(32);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addSeriesBar", function() { return __WEBPACK_IMPORTED_MODULE_7__series_bar__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "barSeriesRender", function() { return __WEBPACK_IMPORTED_MODULE_7__series_bar__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__series_line__ = __webpack_require__(33);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addSeriesLine", function() { return __WEBPACK_IMPORTED_MODULE_8__series_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__series_scatter__ = __webpack_require__(34);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addSeriesScatter", function() { return __WEBPACK_IMPORTED_MODULE_9__series_scatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__size__ = __webpack_require__(35);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resizeChart", function() { return __WEBPACK_IMPORTED_MODULE_10__size__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeChartResponsive", function() { return __WEBPACK_IMPORTED_MODULE_10__size__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handleResize", function() { return __WEBPACK_IMPORTED_MODULE_10__size__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setChartSize", function() { return __WEBPACK_IMPORTED_MODULE_10__size__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tooltip__ = __webpack_require__(36);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initTooltipSingular", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "showSingularTooltip", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hideTooltipSingular", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hideTooltipSingularElement", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initTooltipShared", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateTooltipShared", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bisectTooltip", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTooltipBisectedValue", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drawTooltipShared", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drawTooltipLine", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPointsForTooltip", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeTooltipShared", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeTooltipLine", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handleTooltipSingularMouseEvents", function() { return __WEBPACK_IMPORTED_MODULE_11__tooltip__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__x_axis__ = __webpack_require__(37);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "callXAxis", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addXAxis", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "_addXAxisLabelInner", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addXAxisLabel", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatXAxisLine", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatXAxisTicks", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addXAxisGridLines", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "xTickPositionBetween", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fitXAxisLabels", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "callLabelAdjustment", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getXAxisSpaceBetweenTicks", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "determineLabelAdjustmentMethod", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrapLabels", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rotateLabels", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unadjustLabels", function() { return __WEBPACK_IMPORTED_MODULE_12__x_axis__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__y_axis__ = __webpack_require__(38);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "callYAxis", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addYAxis", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatYAxisLine", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatYAxisTicks", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "_addYAxisLabelInner", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addYAxisLabel", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "callYAxisGridlines", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addYAxisGridLines", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addYAxisPlotlines", function() { return __WEBPACK_IMPORTED_MODULE_13__y_axis__["e"]; });















/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createDefs;
/* harmony export (immutable) */ __webpack_exports__["a"] = addGradientDef;
function createDefs() {
  // Will build out any defs tags that the svg needs. Only use-case currently is gradients
  var defs = this.chartConfig.defs;

  if (!this.defs) {
    this.defs = this.chart.append('defs');
  }
  for (var defType in defs) {
    for (var i = 0; i < defs[defType].length; i++) {
      if (!this.defsIds[defs[defType][i].id]) {
        this.defsIds[defs[defType][i].id] = true;
        this.addDef[defType](defs[defType][i]);
      }
    }
  }
}

function addGradientDef(gradient) {
  var stops = gradient.stops,
      _gradient$coords = gradient.coords,
      coords = _gradient$coords === undefined ? {
    x1: '0%',
    x2: '0%',
    y1: '0%',
    y2: '100%'
  } : _gradient$coords;

  var def = this.defs.append(gradient.type).attr('id', gradient.id).attr('x1', coords.x1).attr('x2', coords.x2).attr('y1', coords.y1).attr('y2', coords.y2);

  for (var i in stops) {
    var stop = stops[i];
    def.append('stop').attr('offset', stop.offset).attr('stop-color', stop.color).attr('stop-opacity', stop.opacity);
  }
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = optionHelper;
/* harmony export (immutable) */ __webpack_exports__["d"] = optionHelperCall;
/* harmony export (immutable) */ __webpack_exports__["b"] = colorHelper;
/* harmony export (immutable) */ __webpack_exports__["e"] = percentOfParentSize;
/* harmony export (immutable) */ __webpack_exports__["f"] = styleLabels;
/* harmony export (immutable) */ __webpack_exports__["g"] = styleLabelsGroup;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyConfigForSeriesGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(0);




function optionHelper(option, optionArgs) {
  if (typeof option === 'function') {
    option = Object(__WEBPACK_IMPORTED_MODULE_2_utils__["bindAppend"])(option, this, optionArgs);
    return function (d) {
      return option(d);
    };
  }
  return option;
}

function optionHelperCall(option, optionArgs) {
  if (typeof option === 'function') {
    return this.optionHelper(option, optionArgs)();
  }
  return option;
}

function colorHelper(color) {
  if (typeof color === 'function') {
    color = Object(__WEBPACK_IMPORTED_MODULE_2_utils__["bindAppend"])(color, this);
    return function (d) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["colorStringHelper"])(color(d));
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2_utils__["colorStringHelper"])(color);
}

function percentOfParentSize(pctValue, parentAttr) {
  return parseFloat(pctValue.slice(0, pctValue.length - 1)) / 100 * this.node.parentNode[parentAttr];
}

// Styles labels by looking for config.style and falling back to individual config options
function styleLabels(selection, config) {
  var _this = this;

  var attrsMapping = {
    color: 'fill',
    fontSize: 'font-size',
    fontWeight: 'font-weight'
  };
  if (config.style) {
    var _optionHelper = this.optionHelper;
    selection.each(function (d) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(this);
      var attrsInStyle = {};
      var style = _optionHelper(config.style, label);
      style = typeof style === 'function' ? style(d) : style;
      for (var attr in style) {
        if (attrsMapping.hasOwnProperty(attr)) {
          attrsInStyle[attr] = true;
          label.attr(attrsMapping[attr], style[attr]);
        }
      }
      var attrsToApply = Object(__WEBPACK_IMPORTED_MODULE_2_utils__["removeFromArray"])(Object.keys(attrsMapping), Object.keys(attrsInStyle));
      attrsToApply.forEach(function (attr) {
        label.attr(attrsMapping[attr], _optionHelper(config[attr], [label]));
      });
    });
  } else {
    // Apply styles not defined in config.style
    Object.keys(attrsMapping).forEach(function (attr) {
      selection.attr(attrsMapping[attr], _this.optionHelper(config[attr], selection));
    });
  }
}

function styleLabelsGroup(selection, seriesGroup) {
  var _this2 = this;

  seriesGroup.forEach(function (series) {
    _this2.styleLabels(selection.filter(function (d) {
      return d.seriesId === series.id;
    }), series.label);
  });
}

// Applies config for a grouped series (used for bar charts)
function applyConfigForSeriesGroup(d, configPath, helperFnType, seriesMapping) {
  var seriesConfig = seriesMapping[d.seriesId];
  var helperFns = {
    color: this.colorHelper,
    option: this.optionHelper,
    optionCall: this.optionHelperCall
  };
  var helperFn = helperFns[helperFnType];
  if (seriesConfig && helperFn) {
    var value = helperFn(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(seriesConfig, configPath.split('.')));
    return typeof value === 'function' ? value(d) : value;
  }
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initLegend;
function initLegend() {
  var legendConfig = this.chartConfig.legend;
  this.setState({
    Legend: legendConfig.component,
    legendType: legendConfig.type
  }, this.resizeChart);
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initChart;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateChart;
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldChartUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils__ = __webpack_require__(0);



function initChart() {
  this.setChartSize();

  var chartConfig = this.chartConfig.chart;
  this.chart = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["select"])(this.node).attr('width', this.outerWidth).attr('height', this.outerHeight).attr('class', this.optionHelperCall(chartConfig.className));

  // Setup layers
  var l = 0;
  while (l <= 10) {
    this.layers[l] = this.chart.append('g').attr('class', 'layer layer--' + l).attr('width', this.outerWidth).attr('height', this.outerHeight).attr('transform', 'translate(' + chartConfig.margin.left + ', ' + chartConfig.margin.top + ')');
    l++;
  }

  this.createDefs();
  this.updateScales();
  this.updateSeries();

  if (this.chartConfig.tooltip.shared && this.chartConfig.tooltip.shared.enabled !== false && !this.tooltipShared) {
    this.initTooltipShared();
  }
  if (this.chartConfig.tooltip.singular && this.chartConfig.tooltip.singular.enabled !== false && !this.tooltipSingular) {
    this.initTooltipSingular();
  }

  if (this.chartConfig.legend && this.chartConfig.legend.enabled !== false) {
    this.initLegend();
  }

  this.init = true;
}

function updateChart() {
  if (this.shouldChartUpdate()) {
    var scalesUpdated = this.updateScales();
    if (scalesUpdated || this.chartConfig.series.length !== this.chartConfigPrev.series.length) {
      this.updateSeries();
    }
    if (this.tooltipMask) {
      this.updateTooltipShared();
    }
  }
}

function shouldChartUpdate() {
  var series = this.chartConfig.series;

  if (this.isResizing || this.chartConfig.series.length !== this.chartConfigPrev.series.length) {
    return true;
  }

  if (this.chartConfig.chart.id !== this.chartConfigPrev.chart.id) {
    this.removeAllSeries();
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1_utils__["isObject"])(series)) {
    if (this.shouldUpdateSeries(series)) {
      return true;
    }
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_utils__["isArray"])(series)) {
    for (var s = 0; s < series.length; s++) {
      if (this.shouldUpdateSeries(series[s])) {
        return true;
      }
    }
  }
  return false;
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildScaleBand;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildScaleTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildScaleLinear;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateScales;
/* harmony export (immutable) */ __webpack_exports__["d"] = scaleHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(0);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}







function buildScaleBand(axis, scaleOptions) {
  var paddingType = scaleOptions.paddingType,
      paddingFloor = scaleOptions.paddingFloor,
      paddingCeil = scaleOptions.paddingCeil;

  var scale = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["scaleBand"])().domain(this.data[axis]).rangeRound([paddingType === 'px' ? paddingFloor : 0, (axis === 'y' ? this.chartHeight : this.chartWidth) - (paddingType === 'px' ? paddingCeil : 0)]).align(scaleOptions.align);
  if (scaleOptions.padding !== null && scaleOptions.padding !== undefined) {
    scale.padding(scaleOptions.padding);
  } else {
    if (scaleOptions.paddingOuter !== null && scaleOptions.paddingOuter !== undefined) {
      scale.paddingOuter(scaleOptions.paddingOuter);
    } else if (scaleOptions.paddingInner !== null && scaleOptions.paddingInner !== undefined) {
      scale.paddingInner(scaleOptions.paddingInner);
    }
  }
  return scale;
}

function buildScaleTime(axis, scaleOptions) {
  var scaleFloor = this.scaleHelper('floor', axis, scaleOptions);
  var scaleCeil = this.scaleHelper('ceil', axis, scaleOptions);
  var paddingType = scaleOptions.paddingType,
      paddingFloor = scaleOptions.paddingFloor,
      paddingCeil = scaleOptions.paddingCeil,
      niceScale = scaleOptions.niceScale;

  var scale = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["scaleTime"])().domain(axis === 'y' ? [scaleCeil, scaleFloor] : [scaleFloor, scaleCeil]).rangeRound([paddingType === 'px' ? paddingFloor : 0, (axis === 'y' ? this.chartHeight : this.chartWidth) - (paddingType === 'px' ? paddingCeil : 0)]);
  if (niceScale) scale.nice();
  return scale;
}

function buildScaleLinear(axis, scaleOptions) {
  var scaleFloor = this.scaleHelper('floor', axis, scaleOptions);
  var scaleCeil = this.scaleHelper('ceil', axis, scaleOptions);
  var paddingType = scaleOptions.paddingType,
      paddingFloor = scaleOptions.paddingFloor,
      paddingCeil = scaleOptions.paddingCeil,
      niceScale = scaleOptions.niceScale;

  var scale = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["scaleLinear"])().domain(axis === 'y' ? [scaleFloor, scaleCeil] : [scaleCeil, scaleFloor]).rangeRound([(axis === 'y' ? this.chartHeight : this.chartWidth) - (paddingType === 'px' ? paddingCeil : 0), paddingType === 'px' ? paddingFloor : 0]);
  if (niceScale) scale.nice();
  return scale;
}

function updateScales() {
  var _this = this;

  var series = this.chartConfig.series;

  var dataX = [];
  var dataY = [];
  // Build complete arrays of x and y values
  if (Object(__WEBPACK_IMPORTED_MODULE_3_utils__["isObject"])(series)) {
    if (series.data && series.data.length) {
      dataX = series.data.map(function (d) {
        return d.x;
      });
      dataY = series.data.map(function (d) {
        return d.y;
      });
      this.dataSeriesSorted[series.id] = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["copyAndSortArray"])(series.data, 'x');
    }
  } else if (Object(__WEBPACK_IMPORTED_MODULE_3_utils__["isArray"])(series)) {
    // TODO: this currently on supports 1 scale type per axis
    series.forEach(function (s, i) {
      if (s.data && s.data.length) {
        dataX = dataX.concat(s.data.map(function (d) {
          return d.x;
        }));
        dataY = dataY.concat(s.data.map(function (d) {
          return d.y;
        }));
        _this.dataSeriesSorted[s.id] = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["copyAndSortArray"])(s.data, 'x');
      }
    });
  }

  if (dataX && dataY && dataX.length && dataY.length) {
    var xScaleOptions = this.chartConfig.xAxis.scale;
    var yScaleOptions = this.chartConfig.yAxis.scale;
    // Combine series data w/ plotline data to set data bounds
    var dataCombinedX = [].concat(_toConsumableArray(dataX), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.chartConfig, ['xAxis', 'plotlines'], []).map(function (p) {
      return p.value;
    })));
    var dataCombinedY = [].concat(_toConsumableArray(dataY), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.chartConfig, ['yAxis', 'plotlines'], []).map(function (p) {
      return p.value;
    })));
    // Store commonly accessed values and complete data sets
    this.dataMax = {
      x: Object(__WEBPACK_IMPORTED_MODULE_1_d3_array__["max"])(dataCombinedX),
      y: Object(__WEBPACK_IMPORTED_MODULE_1_d3_array__["max"])(dataCombinedY)
    };
    this.dataMin = {
      x: Object(__WEBPACK_IMPORTED_MODULE_1_d3_array__["min"])(dataCombinedX),
      y: Object(__WEBPACK_IMPORTED_MODULE_1_d3_array__["min"])(dataCombinedY)
    };
    this.data = {
      x: dataX,
      y: dataY
    };
    this.dataSorted = {
      x: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["copyAndSortArray"])(dataX),
      y: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["copyAndSortArray"])(dataY)
    };
    // Store old scales for use when animating series
    this.xPrev = this.x;
    this.yPrev = this.y;
    // Set new scales
    this.x = this.scaleTypes[xScaleOptions.type]('x', xScaleOptions);
    this.xType = xScaleOptions.type;
    this.y = this.scaleTypes[yScaleOptions.type]('y', yScaleOptions);
    this.yType = yScaleOptions.type;
    return true;
  } else {
    return false;
  }
}

function scaleHelper(side, axis, scaleOptions) {
  var paddingCeil = scaleOptions.paddingCeil,
      paddingFloor = scaleOptions.paddingFloor,
      paddingType = scaleOptions.paddingType;

  var scale = this.optionHelper(scaleOptions[side]);
  var padding = side === 'ceil' ? paddingCeil : paddingFloor * -1;

  var scaleValue = void 0;
  if (scale === 'min') {
    scaleValue = this.dataMin[axis];
  } else if (scale === 'max') {
    scaleValue = this.dataMax[axis];
  } else if (typeof scale === 'number' || Object.prototype.toString.call(scale) === '[object Date]') {
    scaleValue = scale;
  } else {
    return null;
  }

  var paddingValue = 0;
  if (paddingType === 'unit') {
    paddingValue = padding;
  } else if (paddingType === 'pct-min') {
    paddingValue = this.dataMin[axis] * padding;
  } else if (paddingType === 'pct-max') {
    paddingValue = this.dataMax[axis] * padding;
  } else if (paddingType === 'pct-range') {
    paddingValue = (this.dataMax[axis] - this.dataMin[axis]) * padding;
  }
  // NOTE: paddingType === 'px' is handled outside of the helper and is applied to the range

  if (Object.prototype.toString.call(scaleValue) === '[object Date]') {
    scaleValue = new Date().setTime(scaleValue.getTime() + paddingValue);
  } else {
    scaleValue = scaleValue + paddingValue;
  }
  return scaleValue;
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = updateSeries;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeSeries;
/* harmony export (immutable) */ __webpack_exports__["a"] = removeAllSeries;
/* harmony export (immutable) */ __webpack_exports__["c"] = shouldUpdateSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(3);



function updateSeries() {
  var _this = this;

  // Setup object of all current series
  // to determine which should be removed after update
  var seriesToRemove = {};
  Object.keys(this.series).forEach(function (seriesId) {
    seriesToRemove[seriesId] = true;
  });

  var updated = false;
  var shouldUpdateBarSeries = false;
  var series = this.chartConfig.series;
  // To group or stack bar series, they must be applied simultaneously

  var barSeries = [];
  var _updateSeries = function _updateSeries(s) {
    if (s.dataId) {
      _this.seriesDataId[s.id] = s.dataId;
    }

    if (s.tooltip && s.tooltip.enabled !== false && s.tooltip.type === 'shared') {
      _this.seriesTooltip[s.id] = s;
    }
    updated = true;
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_0_utils__["isObject"])(series)) {
    delete seriesToRemove[series.id];
    if (this.shouldUpdateSeries(series)) {
      _updateSeries(series);
      if (series.type === 'bar') {
        barSeries.push(series);
        shouldUpdateBarSeries = true;
      }
      this.addSeries[series.type](series);
    }
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_utils__["isArray"])(series)) {
    for (var i in series) {
      delete seriesToRemove[series[i].id];
      if (series[i].type === 'bar') {
        barSeries.push(series[i]);
        if (this.shouldUpdateSeries(series[i])) {
          shouldUpdateBarSeries = true;
          _updateSeries(series[i]);
        }
      } else {
        if (this.shouldUpdateSeries(series[i])) {
          _updateSeries(series[i]);
          this.addSeries[series[i].type](series[i]);
        }
      }
    }
    // Update all bar series
    if (shouldUpdateBarSeries) {
      this.addSeries.bar(barSeries);
    }
  }
  this.updateOnResize = false;
  if (updated || Object.keys(seriesToRemove).length) {
    for (var seriesId in seriesToRemove) {
      if (shouldUpdateBarSeries && [__WEBPACK_IMPORTED_MODULE_1__constants__["BAR_CHART_CLASSNAME_BAR"], __WEBPACK_IMPORTED_MODULE_1__constants__["BAR_CHART_CLASSNAME_GROUP"]].indexOf(seriesId) === -1 || !shouldUpdateBarSeries) {
        this.removeSeries(seriesId);
      }
    }
    this.addXAxis();
    this.addYAxis();
  }
}

function removeSeries(seriesId) {
  var classNamePoints = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["makeClassNamePoints"])(seriesId);
  var classNameLabels = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["makeClassNameLabels"])(seriesId);
  var points = this.chart.selectAll('.' + classNamePoints);
  var labels = this.chart.selectAll('.' + classNameLabels);
  points.remove();
  labels.remove();
  delete this.series[seriesId];
  delete this.seriesDataId[seriesId];
  delete this.seriesTooltip[seriesId];
}

function removeAllSeries() {
  for (var seriesId in this.series) {
    this.removeSeries(seriesId);
  }
}

function shouldUpdateSeries(series) {
  return series.data && series.data.length && ((series.dataId ? series.dataId !== this.seriesDataId[series.id] : true) || this.updateOnResize) || this.chartConfig && this.chartConfig.series && this.chartConfigPrev && this.chartConfigPrev.series && this.chartConfig.series.length !== this.chartConfigPrev.series.length;
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeriesArea;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate_path__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3_shape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(0);






function addSeriesArea(seriesConfig) {
  var _this = this;

  var animation = seriesConfig.animation;
  var stroke = seriesConfig.stroke;
  var data = seriesConfig.data;

  if (data && data.length) {
    // Used for selecting this series' elements
    var classNamePoints = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["makeClassNamePoints"])(seriesConfig.id);

    // Add element if chart doesn't exist yet
    if (!this.series[seriesConfig.id]) {
      this.layers[seriesConfig.zIndex].append('path').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()(classNamePoints, this.optionHelperCall(seriesConfig.className)));
    }

    var path = this.chart.selectAll('.' + classNamePoints).datum(data).attr('fill', this.colorHelper(seriesConfig.fill)).attr('stroke', this.colorHelper(stroke.color)).attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round').attr('stroke-width', this.optionHelper(stroke.width));

    var areaEnter = Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["area"])().x(function (d) {
      return _this.xPrev ? _this.xPrev(d.x) : _this.x(data[0].x);
    }).y0(this.y(this.dataMin.y)).y1(function (d) {
      return _this.yPrev ? _this.yPrev(d.y) : _this.y(d.y);
    });

    if (!this.series[seriesConfig.id]) {
      path.attr('d', areaEnter);
    }

    var area = Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["area"])().x(function (d) {
      return _this.x(d.x);
    }).y0(this.y(this.dataMin.y)).y1(function (d) {
      return _this.y(d.y);
    });

    // Calculate delay so multiple area series animate in turn
    var duration = this.optionHelper(animation.duration);
    path.transition().ease(this.optionHelper(animation.ease)).duration(duration).attr('stroke-dashoffset', 0).attrTween('d', function (d) {
      var previous = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(this).attr('d');
      var current = area(d);
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate_path__["interpolatePath"])(previous, current);
    });

    this.series[seriesConfig.id] = path;
  }
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeriesBar;
/* harmony export (immutable) */ __webpack_exports__["b"] = barSeriesRender;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_transition__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};







var _zeroIfNaN = function _zeroIfNaN(v) {
  return isNaN(v) ? 0 : v;
};

function addSeriesBar(allBarSeries) {
  var isArray = allBarSeries.constructor === Array;
  if (!allBarSeries || isArray && !allBarSeries.length) return;
  // Convert single series to array for single code path from this point
  allBarSeries = isArray ? allBarSeries : [allBarSeries];
  // Combine Data
  var dataTmp = {};
  var seriesIds = [];
  var barSeries = {};
  // Use first defined series as base config
  var defaultSeriesConfig = allBarSeries[0];
  // Reformat data to represent group:
  // {
  //   x: X Axis Category,
  //   [seriesId]: Value for series
  // }
  allBarSeries.forEach(function (series) {
    seriesIds.push(series.id);
    barSeries[series.id] = series;
    series.data.forEach(function (d) {
      if (!dataTmp[d.x]) {
        dataTmp[d.x] = { x: d.x };
      }
      dataTmp[d.x][series.id] = d;
    });
  });
  var data = Object.keys(dataTmp).map(function (k) {
    return dataTmp[k];
  });

  // Setup Group Scale
  this.groupScalePrev = this.groupScale;
  this.groupScale = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["scaleBand"])().domain(seriesIds).rangeRound([0, this.x.bandwidth()]).padding(0.1);
  if (!this.groupScalePrev) {
    // Set this.groupScalePrev on first render
    this.groupScalePrev = this.groupScale;
  }

  this.barWidth = this.groupScale.bandwidth();

  // Set transition to be reused by axis animations
  if (defaultSeriesConfig.animation) {
    this.transition = Object(__WEBPACK_IMPORTED_MODULE_1_d3_transition__["transition"])().delay(defaultSeriesConfig.animation.delay).ease(defaultSeriesConfig.animation.ease).duration(defaultSeriesConfig.animation.duration);
  }

  this.barSeriesRender(data, seriesIds, defaultSeriesConfig, barSeries, allBarSeries);
}

function barSeriesRender(data, seriesIds, defaultSeriesConfig, barSeries, allBarSeries) {
  var _this = this;

  // Render Grouped Series
  var seriesLayer = this.layers[allBarSeries[0].zIndex];
  var classNameBars = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["makeClassNamePoints"])(__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_BAR"]);
  var classNameGroups = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["makeClassNamePoints"])(__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_GROUP"]);
  var classNameLabels = Object(__WEBPACK_IMPORTED_MODULE_3_utils__["makeClassNameLabels"])(__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_LABEL"]);

  // Groups -----------------
  var groups = seriesLayer.selectAll('.' + classNameGroups).data(data);
  // Setup Exit animations
  var exitGroup = groups.exit();
  exitGroup.selectAll('.' + classNameBars).transition().duration(defaultSeriesConfig.animation.duration).attr('d', function (d) {
    // O height in final x position
    return '\n        M' + _zeroIfNaN(_this.groupScalePrev(d.seriesId)) + ',' + _zeroIfNaN(_this.chartHeight) + '\n        a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + -0 + '\n        h' + _zeroIfNaN(_this.groupScalePrev.bandwidth() - 2 * 0) + '\n        a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + 0 + '\n        v' + 0 + '\n        h' + -_zeroIfNaN(_this.groupScalePrev.bandwidth()) + 'Z\n      ';
  });
  exitGroup.transition().duration(defaultSeriesConfig.animation.duration).attr('transform', function (d) {
    return 'translate(' + (_this.chartWidth + _this.xPrev(d.x)) + ',0)';
  }).remove();

  var enterGroups = groups.enter().append('g').attr('class', classNameGroups);

  if (this.series[__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_GROUP"]]) {
    enterGroups.attr('transform', 'translate(' + this.chartWidth + ',0)');
  } else {
    enterGroups.attr('transform', function (d) {
      return 'translate(' + _this.x(d.x) + ',0)';
    });
  }

  // Update groups after data changes
  groups = groups.merge(enterGroups);

  // Bars -----------------
  var bars = groups.selectAll('.' + classNameBars).data(function (d) {
    return seriesIds.map(function (seriesId) {
      // Reformat data for individual bars in group
      if (d[seriesId] !== null && d[seriesId] !== undefined) {
        return _extends({ seriesId: seriesId }, d[seriesId]);
      }
    }).filter(function (p) {
      return !!p;
    });
  });

  bars.exit().transition().duration(defaultSeriesConfig.animation.duration).attr('d', function (d) {
    // O height in final x position
    return '\n        M' + _zeroIfNaN(_this.groupScalePrev(d.seriesId)) + ',' + _zeroIfNaN(_this.chartHeight) + '\n        a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + -0 + '\n        h' + _zeroIfNaN(_this.groupScalePrev.bandwidth() - 2 * 0) + '\n        a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + 0 + '\n        v' + 0 + '\n        h' + -_zeroIfNaN(_this.groupScalePrev.bandwidth()) + 'Z\n      ';
  });

  groups.transition().duration(500).attr('transform', function (d) {
    return 'translate(' + _this.x(d.x) + ',0)';
  });

  // Add Bars To Chart
  var enterBars = bars.enter().append('path').attr('class', function (d) {
    return __WEBPACK_IMPORTED_MODULE_4_classnames___default()(classNameBars, Object(__WEBPACK_IMPORTED_MODULE_3_utils__["makeClassNamePoints"])(d.seriesId));
  }).attr('x', function (d) {
    return _this.groupScale(d.seriesId);
  }).attr('width', this.barWidth).attr('y', this.chartHeight).attr('fill', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'fill', 'color', barSeries);
  }).attr('stroke', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'stroke.color', 'color', barSeries);
  }).attr('stroke-width', 0).attr('d', function (d) {
    // 0 height in final x-position
    return '\n      M' + _zeroIfNaN(_this.groupScale(d.seriesId)) + ',' + _zeroIfNaN(_this.chartHeight) + '\n      a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + -0 + '\n      h' + _zeroIfNaN(_this.groupScale.bandwidth() - 2 * 0) + '\n      a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + 0 + '\n      v' + 0 + '\n      h' + -_zeroIfNaN(_this.groupScale.bandwidth()) + 'Z\n      ';
  });

  // Update Existing Bars and Animate New Bars After Data Change
  bars = bars.merge(enterBars).attr('fill', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'fill', 'color', barSeries);
  }).attr('stroke', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'stroke.color', 'color', barSeries);
  }).transition(this.transition).attr('width', this.barWidth).attr('x', function (d) {
    return _this.groupScale(d.seriesId);
  }).attr('y', function (d) {
    return _this.y(d.y || _this.dataMin.y);
  }).attr('stroke-width', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'stroke.width', 'option', barSeries);
  }).attr('d', function (d) {
    var seriesConfig = barSeries[d.seriesId];
    if (seriesConfig && d.y !== null && d.y !== undefined) {
      var borderRadius = seriesConfig.borderRadius;

      return '\n          M' + _zeroIfNaN(_this.groupScale(d.seriesId)) + ',' + _zeroIfNaN(_this.y(d.y) + borderRadius[1]) + '\n          a' + borderRadius[0] + ',' + borderRadius[1] + ' 0 0 1 ' + borderRadius[0] + ',' + -borderRadius[1] + '\n          h' + _zeroIfNaN(_this.groupScale.bandwidth() - 2 * borderRadius[0]) + '\n          a' + borderRadius[0] + ',' + borderRadius[1] + ' 0 0 1 ' + borderRadius[0] + ',' + borderRadius[1] + '\n          v' + _zeroIfNaN(_this.chartHeight - _this.y(d.y) - borderRadius[1]) + '\n          h' + -_zeroIfNaN(_this.groupScale.bandwidth()) + 'Z\n          ';
    } else {
      // 0 height in x-position when the series does not exist
      return '\n          M' + _zeroIfNaN(_this.groupScale(d.seriesId)) + ',' + _zeroIfNaN(_this.chartHeight) + '\n          a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + -0 + '\n          h' + _zeroIfNaN(_this.groupScale.bandwidth() - 2 * 0) + '\n          a' + 0 + ',' + 0 + ' 0 0 1 ' + 0 + ',' + 0 + '\n          v' + 0 + '\n          h' + -_zeroIfNaN(_this.groupScale.bandwidth()) + 'Z\n          ';
    }
  });

  // Labels -----------------
  var labels = groups.selectAll('.' + classNameLabels).data(function (d) {
    return seriesIds.map(function (seriesId) {
      // Reformat data for individual bars in group
      if (barSeries[seriesId].label.enabled !== false && d[seriesId] !== null && d[seriesId] !== undefined) {
        return _extends({ seriesId: seriesId }, d[seriesId]);
      }
    }).filter(function (p) {
      return !!p;
    });
  });

  labels.exit().transition().duration(defaultSeriesConfig.animation.duration).attr('y', this.chartHeight).remove();

  var enterLabels = labels.enter().append('text').attr('class', classNameLabels).attr('y', this.chartHeight).attr('opacity', 0);

  if (this.series[__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_GROUP"]]) {
    enterLabels.attr('x', this.chartWidth);
    this.styleLabelsGroup(labels, allBarSeries);
  } else {
    enterLabels.attr('x', function (d) {
      return _this.groupScale(d.seriesId) + _this.barWidth / 2;
    });
  }

  labels = labels.merge(enterLabels).attr('text-anchor', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'label.anchor', 'option', barSeries);
  }).attr('font-family', __WEBPACK_IMPORTED_MODULE_2__constants__["FONT_FAMILY"]).text(function (d) {
    return _this.applyConfigForSeriesGroup(d, 'label.format', 'option', barSeries);
  });
  labels.transition(this.transition).attr('dy', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'label.adjustY', 'option', barSeries);
  }).attr('dx', function (d) {
    return _this.applyConfigForSeriesGroup(d, 'label.adjustX', 'option', barSeries);
  }).attr('y', function (d) {
    return _this.y(d.y);
  }).attr('x', function (d) {
    return _this.groupScale(d.seriesId) + _this.barWidth / 2;
  });
  labels.transition().delay(defaultSeriesConfig.animation.duration).duration(300).attr('opacity', 1);

  this.styleLabelsGroup(labels, allBarSeries);
  // Add all series to lookup
  allBarSeries.forEach(function (series) {
    var seriesBars = seriesLayer.selectAll('.' + Object(__WEBPACK_IMPORTED_MODULE_3_utils__["makeClassNamePoints"])(series.id));
    _this.handleTooltipSingularMouseEvents(seriesBars, series);
    _this.series[series.id] = seriesBars;
  });
  this.series[__WEBPACK_IMPORTED_MODULE_2__constants__["BAR_CHART_CLASSNAME_GROUP"]] = seriesLayer.selectAll('.' + classNameGroups);
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeriesLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_shape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_interpolate_path__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_interpolate_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3_interpolate_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(0);






function addSeriesLine(seriesConfig) {
  var _this = this;

  var animation = seriesConfig.animation;
  var stroke = seriesConfig.stroke;
  var data = seriesConfig.data;

  if (data && data.length) {
    var classNamePoints = Object(__WEBPACK_IMPORTED_MODULE_4_utils__["makeClassNamePoints"])(seriesConfig.id);
    var isEntering = !this.series[seriesConfig.id];
    // Add element if chart doesn't exist yet
    if (isEntering) {
      this.layers[seriesConfig.zIndex].append('path').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()(classNamePoints, this.optionHelperCall(seriesConfig.className)));
    }

    var line = Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape__["line"])().defined(function (d) {
      return d.y;
    }).x(function (d) {
      return _this.x(d.x);
    }).y(function (d) {
      return _this.y(d.y);
    });

    var path = this.chart.selectAll('.' + classNamePoints).datum(data).attr('d', line).attr('fill', 'none').attr('stroke', this.colorHelper(stroke.color)).attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round').attr('stroke-width', this.optionHelper(stroke.width));

    var totalLength = path.node().getTotalLength();
    if (isEntering) {
      path.attr('stroke-dasharray', totalLength + ' ' + totalLength).attr('stroke-dashoffset', totalLength).transition().duration(animation.durationEnter || animation.duration).ease(animation.ease).attr('stroke-dashoffset', 0);
    } else {
      var offset = path.attr('stroke-dashoffset');
      path.attr('stroke-dasharray', totalLength + ' ' + totalLength).transition().ease(animation.ease).duration(2000 || animation.duration).attr('stroke-dashoffset', 0).attrTween('d', function (d) {
        var previous = Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(this).attr('d');
        var current = line(d);
        return Object(__WEBPACK_IMPORTED_MODULE_3_d3_interpolate_path__["interpolatePath"])(previous, current);
      });
      path.transition().ease(animation.ease).duration(offset / totalLength * animation.duration).attr('stroke-dashoffset', 0);
    }

    this.series[seriesConfig.id] = path;
  }
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeriesScatter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



function addSeriesScatter(seriesConfig) {
  var _this = this;

  var animationConfig = seriesConfig.animation;
  var strokeConfig = seriesConfig.stroke;
  var data = seriesConfig.data,
      id = seriesConfig.id,
      zIndex = seriesConfig.zIndex,
      pointImg = seriesConfig.pointImg,
      svgFragment = seriesConfig.svgFragment;

  if (data && data.length) {
    // Used for selecting this series' elements
    var layer = this.layers[zIndex];
    var classNamePoints = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["makeClassNamePoints"])(id);
    var series = layer.selectAll('.' + classNamePoints).data(data).attr('class', __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classNamePoints, this.optionHelperCall(seriesConfig.className)));

    if (this.series[seriesConfig.id]) {
      // Update tooltip events for existing points
      this.handleTooltipSingularMouseEvents(series, seriesConfig);
    }

    var points = void 0;

    if (!pointImg && !svgFragment) {
      points = series.enter().append('circle');
      points.attr('class', __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classNamePoints, this.optionHelper(seriesConfig.className))).attr('r', this.optionHelper(seriesConfig.radius)).attr('fill', this.colorHelper(seriesConfig.fill)).style('stroke-width', this.optionHelper(strokeConfig.width)).attr('stroke', this.colorHelper(strokeConfig.color)).attr('cx', function (d) {
        return _this.xPrev ? _this.xPrev(d.x) : _this.x(d.x);
      }).attr('cy', function (d) {
        return _this.yPrev ? _this.yPrev(d.y) : _this.dataMax.y + _this.dataMax.y * 0.25;
      });

      points.merge(series).transition().ease(this.optionHelper(animationConfig.ease)).duration(this.optionHelper(animationConfig.duration)).attr('cx', function (d) {
        return _this.x(d.x);
      }).attr('cy', function (d) {
        return _this.y(d.y);
      });
    }

    if (seriesConfig.shape === 'image') {
      points = series.enter().append('image');
      points.attr('class', __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classNamePoints, this.optionHelper(seriesConfig.className))).attr('xlink:href', pointImg).attr('width', this.optionHelper(seriesConfig.pointWidth)).attr('height', this.optionHelper(seriesConfig.pointHeight));

      // Adjust position so the center of the image is on the correct coordinates
      points.merge(series).transition().ease(this.optionHelper(animationConfig.ease)).duration(this.optionHelper(animationConfig.duration)).attr('x', function (d) {
        return _this.x(d.x);
      }).attr('y', function (d) {
        return _this.y(d.y);
      }).attr('transform', 'translate(' + seriesConfig.adjustX + ', ' + seriesConfig.adjustY + ')');
    }

    if (svgFragment) {
      points = series.enter().append('g').html(this.optionHelper(svgFragment));
      points.attr('class', __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classNamePoints, this.optionHelper(seriesConfig.className)));

      // Translate to point position and adjust so the center of the image is on the correct coordinates
      points.merge(series).transition().ease(this.optionHelper(animationConfig.ease)).duration(this.optionHelper(animationConfig.duration)).attr('transform', function (d) {
        return 'translate(' + (_this.x(d.x) + seriesConfig.adjustSvgFragmentX) + ', ' + (_this.y(d.y) + seriesConfig.adjustSvgFragmentY) + ')';
      });
    }

    this.handleTooltipSingularMouseEvents(points, seriesConfig);
    series.exit().remove();
    this.series[seriesConfig.id] = series;
  }
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = resizeChart;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeChartResponsive;
/* harmony export (immutable) */ __webpack_exports__["a"] = handleResize;
/* harmony export (immutable) */ __webpack_exports__["d"] = setChartSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils__ = __webpack_require__(0);


function resizeChart() {
  this.setChartSize();

  this.chart.attr('width', this.outerWidth).attr('height', this.outerHeight);

  for (var l in this.layers) {
    this.layers[l].attr('width', this.chartWidth).attr('height', this.chartHeight).attr('transform', 'translate(' + this.chartConfig.chart.margin.left + ', ' + this.chartConfig.chart.margin.top + ')');
  }

  this.updateOnResize = true;
  this.updateChart();
  this.isResizing = false;
}

function makeChartResponsive() {
  if (!this.isResponsive) {
    this.isResponsive = true;
    window.addEventListener('resize', this.handleResize);
  }
}

function handleResize() {
  if (!this.isResizing) {
    this.resizeChartAnimationFrame = window.requestAnimationFrame(this.resizeChart);
    this.isResizing = true;
  }
}

function setChartSize() {
  var chartConfig = this.chartConfig.chart;
  var width = chartConfig.width,
      height = chartConfig.height,
      margin = chartConfig.margin;

  var isPctWidth = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["isPercentValue"])(width);
  var isPctHeight = Object(__WEBPACK_IMPORTED_MODULE_0_utils__["isPercentValue"])(height);

  if (isPctWidth || isPctHeight) {
    this.makeChartResponsive();
  }

  this.outerWidth = isPctWidth ? this.percentOfParentSize(width, 'offsetWidth') : width;
  this.outerHeight = isPctHeight ? this.percentOfParentSize(height, 'offsetHeight') : height;
  this.chartWidth = this.outerWidth - margin.left - margin.right;
  this.chartHeight = this.outerHeight - margin.top - margin.bottom;
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = initTooltipSingular;
/* harmony export (immutable) */ __webpack_exports__["m"] = showSingularTooltip;
/* harmony export (immutable) */ __webpack_exports__["g"] = hideTooltipSingular;
/* harmony export (immutable) */ __webpack_exports__["h"] = hideTooltipSingularElement;
/* harmony export (immutable) */ __webpack_exports__["i"] = initTooltipShared;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateTooltipShared;
/* harmony export (immutable) */ __webpack_exports__["a"] = bisectTooltip;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTooltipBisectedValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = drawTooltipShared;
/* harmony export (immutable) */ __webpack_exports__["b"] = drawTooltipLine;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPointsForTooltip;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeTooltipShared;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeTooltipLine;
/* harmony export (immutable) */ __webpack_exports__["f"] = handleTooltipSingularMouseEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_selection__);



function initTooltipSingular() {
  this.tooltipSingularConfig = this.chartConfig.tooltip.singular;
  if (this.tooltipSingularConfig.component) {
    this.tooltipSingular = this.tooltipSingularConfig.component;
  }
}

function showSingularTooltip(tooltipSingularPoint, tooltipSingularPosition) {
  clearTimeout(this.hideTooltipSingularTimeout);
  this.setState({
    tooltipSingularPoint: tooltipSingularPoint,
    tooltipSingularPosition: tooltipSingularPosition
  });
}

function hideTooltipSingular() {
  this.hideTooltipSingularTimeout = setTimeout(this.hideTooltipSingularElement, this.chartConfig.tooltip.singular.timeoutHide);
}

function hideTooltipSingularElement() {
  this.setState({
    tooltipSingularPoint: null
  });
}

function initTooltipShared() {
  this.tooltipSharedConfig = this.chartConfig.tooltip.shared;
  if (this.tooltipSharedConfig.component) {
    this.tooltipShared = this.tooltipSharedConfig.component;
    if (this.tooltipSharedConfig.line && !this.tooltipLine) {
      this.tooltipLine = this.chart.selectAll('.layer--' + this.tooltipSharedConfig.zIndex).append('line');
      if (this.tooltipSharedConfig.line.className) {
        this.tooltipLine.attr('class', this.tooltipSharedConfig.line.className);
      }
    }
    if (!this.tooltipMask) {
      var chartConfig = this.chartConfig.chart;
      // TODO: The height and width of this aren't working properly. Hopefully the chartHeight/Width optimizations fix it
      this.tooltipMaskLayer = this.layers[this.tooltipSharedConfig.zIndex];
      this.tooltipMask = this.tooltipMaskLayer.append('rect').attr('class', 'layer layer--tooltip-mask').attr('opacity', 0).attr('height', this.chartHeight).attr('width', this.chartWidth).attr('transform', 'translate(' + -chartConfig.margin.left + ', ' + -chartConfig.margin.top + ')').on('mousemove', this.drawTooltipShared).on('mouseout', this.removeTooltipShared);

      this.updateTooltipShared();
    }
  }
}

function updateTooltipShared() {
  var chartOptions = this.chartConfig.chart;
  this.tooltipMask.attr('width', this.outerWidth).attr('height', this.outerHeight).attr('transform', 'translate(' + -chartOptions.margin.left + ', ' + -chartOptions.margin.top + ')');
}

// Factory w/ optional data attribute key argument
function bisectTooltip(attr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function (d) {
    return attr ? d[attr] : d;
  }).left;
}

// Gets the corresponding datapoint based on mouse position
function getTooltipBisectedValue(data, attr) {
  var x0 = this.x.invert(Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["mouse"])(this.tooltipMaskLayer.node())[0]);
  var i = this.bisectTooltip()(data, x0, 1);
  var d0 = attr ? data[i - 1][attr] : data[i - 1];
  var d1 = attr ? data[i][attr] : data[i];
  return x0 - d0 > d1 - x0 ? d1 : d0;
}

function drawTooltipShared() {
  clearTimeout(this.hideTooltipSharedTimeout);
  var xVal = this.getTooltipBisectedValue(this.dataSorted.x);
  var points = this.getPointsForTooltip(xVal);
  if (points && points.length) {
    if (this.tooltipLine) {
      this.drawTooltipLine(xVal);
    }
    var chartConfig = this.chartConfig.chart;
    var xCoord = this.x(xVal) + chartConfig.margin.left;
    this.hideTooltipSharedTimeout = setTimeout(this.removeTooltipShared, this.chartConfig.tooltip.shared.timeoutHide);
    var top = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["mouse"])(this.tooltipMask.node())[1];
    this.setState({
      tooltipSharedPoints: points,
      tooltipSharedPosition: {
        left: xCoord,
        top: top
      },
      tooltipSharedAttach: xCoord - chartConfig.margin.left > this.chartWidth / 2 ? 'left' : 'right'
    });
  }
}

function drawTooltipLine(xVal) {
  var tooltipConfig = this.chartConfig.tooltip.shared;
  var lineConfig = tooltipConfig.line;
  this.tooltipLine.attr('stroke', this.colorHelper(lineConfig.color)).attr('stroke-width', this.optionHelper(lineConfig.width)).attr('x1', this.x(xVal)).attr('x2', this.x(xVal)).attr('y1', 0).attr('y2', this.chartHeight);
}

function getPointsForTooltip(xData) {
  var tipPoints = [];
  var xDataIsDate = xData instanceof Date;
  for (var seriesId in this.seriesTooltip) {
    var point = this.dataSeriesSorted[seriesId] && this.dataSeriesSorted[seriesId].find(function (d) {
      if (xDataIsDate && d.x instanceof Date) {
        var match = xData.getTime() === d.x.getTime();
        return match;
      }
      return d.x === xData;
    });
    if (point && point.y !== null && point.y !== undefined && !point.tooltipExclude) {
      tipPoints.push(point);
    }
  }
  return tipPoints;
}

function removeTooltipShared() {
  clearTimeout(this.hideTooltipSharedTimeout);
  this.removeTooltipLine();
  this.setState({
    tooltipSharedPoints: null,
    tooltipSharedPosition: null,
    tooltipSharedAttach: 'right'
  });
}

function removeTooltipLine() {
  this.tooltipLine.transition().duration(300).attr('stroke', 'transparent');
}

function handleTooltipSingularMouseEvents(selection, seriesConfig) {
  var _this = this;

  var seriesTypeTooltipOffsetX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var seriesTypeTooltipOffsetY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var tooltipConfig = seriesConfig.tooltip;
  if (tooltipConfig || seriesConfig.onMouseOver) {
    selection.on('mouseover', function (d) {
      var margin = _this.chartConfig.chart.margin;

      if (typeof seriesConfig.onMouseOver === 'function') {
        seriesConfig.onMouseOver.apply(_this, [d, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"]]);
      }

      if (tooltipConfig && tooltipConfig.type === 'singular') {
        /**
         * Bar is a path element and style width doesnt directly correspond to the width of the path
         */
        var _selection$node$getBB = selection.node().getBBox(),
            barXPathCoordinate = _selection$node$getBB.x;

        _this.showSingularTooltip(d, {
          left: _this.barWidth ? _this.x(d.x) + seriesTypeTooltipOffsetX + margin.left + tooltipConfig.adjustX + _this.barWidth / 2 + barXPathCoordinate : _this.x(d.x) + seriesTypeTooltipOffsetX + margin.left + tooltipConfig.adjustX,
          top: _this.y(d.y) + seriesTypeTooltipOffsetY + margin.top + tooltipConfig.adjustY
        });
      }
    });
  }

  if (tooltipConfig || seriesConfig.onMouseOut) {
    selection.on('mouseout', function (d) {
      if (typeof seriesConfig.onMouseOut === 'function') {
        seriesConfig.onMouseOut.apply(_this, [d, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["event"]]);
      }
      if (tooltipConfig && tooltipConfig.type === 'singular') {
        _this.hideTooltipSingular(d);
      }
    });
  }
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = callXAxis;
/* harmony export (immutable) */ __webpack_exports__["b"] = addXAxis;
/* harmony export (immutable) */ __webpack_exports__["a"] = _addXAxisLabelInner;
/* harmony export (immutable) */ __webpack_exports__["d"] = addXAxisLabel;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatXAxisLine;
/* harmony export (immutable) */ __webpack_exports__["j"] = formatXAxisTicks;
/* harmony export (immutable) */ __webpack_exports__["c"] = addXAxisGridLines;
/* harmony export (immutable) */ __webpack_exports__["o"] = xTickPositionBetween;
/* harmony export (immutable) */ __webpack_exports__["h"] = fitXAxisLabels;
/* harmony export (immutable) */ __webpack_exports__["e"] = callLabelAdjustment;
/* harmony export (immutable) */ __webpack_exports__["k"] = getXAxisSpaceBetweenTicks;
/* harmony export (immutable) */ __webpack_exports__["g"] = determineLabelAdjustmentMethod;
/* harmony export (immutable) */ __webpack_exports__["n"] = wrapLabels;
/* harmony export (immutable) */ __webpack_exports__["l"] = rotateLabels;
/* harmony export (immutable) */ __webpack_exports__["m"] = unadjustLabels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_axis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(0);
function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








function callXAxis() {
  var ticksConfig = this.chartConfig.xAxis.ticks;
  var labelConfig = ticksConfig.label;
  var axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["axisBottom"])(this.x).ticks(this.optionHelperCall(ticksConfig.count)).tickFormat(this.optionHelper(labelConfig.format));
  if (ticksConfig.values) {
    axis.tickValues(this.optionHelperCall(ticksConfig.values));
  }
  this.xAxisApi = axis;
  return axis;
}

function addXAxis() {
  var _this = this;

  var xAxisOptions = this.chartConfig.xAxis;
  var methodConfigOption = void 0;
  if (xAxisOptions.label && xAxisOptions.ticks.label && xAxisOptions.ticks.label.adjustmentMethod) methodConfigOption = xAxisOptions.ticks.label.adjustmentMethod;
  if (!this.xAxis) {
    this.xAxis = this.layers[xAxisOptions.zIndex].append('g').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()('axis', 'axis--x', this.optionHelper(xAxisOptions.className))).attr('transform', 'translate(0,' + this.chartHeight + ')').call(this.callXAxis());

    setTimeout(function () {
      _this.fitXAxisLabels();
      if (xAxisOptions.label && (Object(__WEBPACK_IMPORTED_MODULE_4_utils__["isArray"])(xAxisOptions.label) || xAxisOptions.label.enabled !== false || xAxisOptions.label.text)) {
        _this.addXAxisLabel();
      }
    }, 0);
  } else {
    this.layers[xAxisOptions.zIndex].select('.axis--x').attr('transform', 'translate(0,' + this.chartHeight + ')').transition(this.transition).call(this.callXAxis()).on('end', function () {
      _this.fitXAxisLabels(methodConfigOption);
      if (xAxisOptions.label && (xAxisOptions.label.enabled !== false || xAxisOptions.label.text)) {
        _this.addXAxisLabel();
      }
    });
  }
  // Hide ticks that don't have a corresponding label
  this.xAxis.select('.domain').attr('stroke', 'transparent');

  // Set font for axis
  this.xAxis.selectAll('text').attr('font-family', __WEBPACK_IMPORTED_MODULE_3__constants__["FONT_FAMILY"]);

  if (xAxisOptions.line) {
    this.formatXAxisLine();
  }
  if (xAxisOptions.ticks) {
    this.formatXAxisTicks();
  }
  if (xAxisOptions.gridLines && xAxisOptions.gridLines.enabled !== false) {
    this.addXAxisGridLines();
  }
}

// Creates the x-axis label and allows them to be styled individually
function _addXAxisLabelInner(labelConfig) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var label = this.xAxis.select('.axis--label--x--' + index);
  if (label.empty()) {
    label = this.xAxis.append('text').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()('axis--label', 'axis--label--x', 'axis--label--x--' + index, this.optionHelperCall(labelConfig.className))).attr('text-anchor', this.optionHelper(labelConfig.anchor, [label])).attr('font-family', __WEBPACK_IMPORTED_MODULE_3__constants__["FONT_FAMILY"]);
  }

  var duration = 300;
  if (labelConfig.animation) {
    duration = labelConfig.animation.duration;
  }

  label.text(labelConfig.text).transition().duration(duration).attr('x', this.optionHelper(labelConfig.x, [label])).attr('dx', this.optionHelper(labelConfig.adjustX, [label])).attr('dy', this.optionHelper(labelConfig.adjustY, [label]));

  this.styleLabels(label, labelConfig);

  return label;
}

// Determine if there are multiple labels and call axis function
function addXAxisLabel() {
  var _this2 = this;

  var labelConfig = this.chartConfig.xAxis.label;
  var xAxisLabels = [];
  if (Object(__WEBPACK_IMPORTED_MODULE_4_utils__["isArray"])(labelConfig)) {
    labelConfig.forEach(function (l, i) {
      xAxisLabels.push(_this2._addXAxisLabelInner(l, i));
    });
  } else {
    xAxisLabels.push(this._addXAxisLabelInner(labelConfig));
  }
  this.xAxisLabels = xAxisLabels;
}

function formatXAxisLine() {
  var line = this.chartConfig.xAxis.line;
  // Hide the oringal line that includes domain ticks
  this.xAxis.select('.domain').attr('stroke', 'transparent');
  var axisLine = Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])('.axis--line--x');
  if (axisLine.empty()) {
    this.xAxis.append('line').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()('axis--line--x', this.optionHelperCall(line.className))).attr('x1', 0).attr('x2', this.chartWidth).attr('y1', 0).attr('y2', 0).attr('stroke', this.colorHelper(line.color)).attr('stroke-width', this.optionHelper(line.width));
  }
}

function formatXAxisTicks() {
  var ticks = this.chartConfig.xAxis.ticks;
  var outer = this.xAxis.selectAll('.tick');
  var lines = outer.selectAll('line').attr('stroke', this.colorHelper(ticks.color)).attr('stroke-width', this.optionHelper(ticks.width)).attr('class', this.optionHelper(ticks.className)).attr('y2', this.optionHelper(ticks.length));

  if (ticks.position === 'between') {
    var adjustment = this.xTickPositionBetween();
    lines.attr('x1', adjustment).attr('x2', adjustment);
    // Add one more tick at the beginning of the axis
    this.xAxis.select('.tick').append('line').attr('stroke', this.colorHelper(ticks.color)).attr('stroke-width', this.optionHelper(ticks.width)).attr('y2', this.optionHelper(ticks.length)).attr('x1', adjustment * -1).attr('x2', adjustment * -1);
  }

  if (ticks.label) {
    this.styleLabels(outer.selectAll('text').attr('class', this.optionHelper(ticks.label.className)), ticks.label);
  }
}

function addXAxisGridLines() {
  var xAxisOptions = this.chartConfig.xAxis;
  var ticks = xAxisOptions.ticks;
  var gridLines = xAxisOptions.gridLines;
  this.chart.selectAll('.grid--x').remove();
  this.gridX = this.layers[xAxisOptions.zIndex].append('g').attr('class', 'grid grid--x').call(Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["axisBottom"])().scale(this.x).ticks(this.optionHelperCall(ticks.count)).tickSize(-this.chartHeight, 0, 0).tickFormat(''));
  // Hide stroke that wraps the whole grid
  this.gridX.select('.domain').attr('stroke', 'transparent');
  this.gridX.selectAll('.tick').selectAll('line').attr('stroke', this.colorHelper(gridLines.color));
}

function xTickPositionBetween() {
  var bandwidth = this.x.bandwidth();
  var padding = this.x.padding();
  return (bandwidth * padding + bandwidth) / 2;
}

function fitXAxisLabels(methodConfigOption) {
  // Fit X Axis labels based on tick width
  var width = this.getXAxisSpaceBetweenTicks();
  if (width) {
    this.xAxis.selectAll('.tick text').call(this.callLabelAdjustment, width, methodConfigOption);
  }
}

function callLabelAdjustment(labels, width, methodConfigOption) {
  var _determineLabelAdjust = this.determineLabelAdjustmentMethod(labels, width),
      method = _determineLabelAdjust.method,
      args = _objectWithoutProperties(_determineLabelAdjust, ['method']);

  var adjustmentMethod = methodConfigOption || method;
  // Unadjust labels so they are unaffected by the rotation adjustment
  this.unadjustLabels(labels, width, args);
  // Keep track of the adjustment method so labels can be reset when it changes
  this.xAxisTickLabelAdjustmentMethod = adjustmentMethod;
  this.labelAdjustmentMethods[adjustmentMethod](labels, width, args);
}

function getXAxisSpaceBetweenTicks() {
  if (this.xType === 'band') {
    return this.x.bandwidth();
  } else {
    var tickValues = this.xAxisApi.tickValues() || this.xAxisApi.scale().ticks();
    if (tickValues && tickValues.length > 1) {
      return this.x(tickValues[1]) - this.x(tickValues[0]) - 10;
    } else {
      // No need to wrap 1 label
      return false;
    }
  }
}

function determineLabelAdjustmentMethod(labels, width) {
  var method = false;
  var maxWidth = void 0;
  labels.each(function () {
    var textSelection = Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(this);
    var text = textSelection.text();
    var node = textSelection && Object(__WEBPACK_IMPORTED_MODULE_4_utils__["isFunc"])(textSelection.node) && textSelection.node();
    var textWidth = node && Object(__WEBPACK_IMPORTED_MODULE_4_utils__["isFunc"])(node.getComputedTextLength) && node.getComputedTextLength();
    if (!maxWidth || textWidth > maxWidth) {
      maxWidth = textWidth;
    }
    var ratio = textWidth / width;
    if (ratio > 2 || ratio > 1 && text.split(' ').length === 1) {
      method = 'rotate';
    } else if (ratio > 1 && method !== 'rotate') {
      method = 'wrap';
    }
  });
  return {
    method: method,
    maxWidth: maxWidth
  };
}

function wrapLabels(labels, width) {
  var wrappedLabel = false;
  var maxHeight = void 0;

  labels.attr('transform', '').each(function () {
    var text = Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(this);
    var words = text.text().split(/\s+/).reverse();
    var fontSize = text.attr('font-size');
    var lineHeight = parseFloat(fontSize) + parseFloat(fontSize) * 0.3;
    var y = text.attr('y');
    var dy = parseFloat(text.attr('dy'));

    var word = words.pop();
    var line = [];
    var lineNumber = 0;

    var tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y).attr('dy', dy);

    while (word) {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > width) {
        wrappedLabel = true;
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        ++lineNumber;
        var dyLine = lineNumber * lineHeight + dy;
        tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', dyLine).text(word);
      }
      word = words.pop();
    }
    var thisHeight = (lineNumber + 1) * lineHeight + dy;
    if (!maxHeight || thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });

  this.adjustedXaXisTickLabelHeight = wrappedLabel ? maxHeight + 15 : null;
}

function rotateLabels(labels, tickWidth, _ref) {
  var maxWidth = _ref.maxWidth;

  // Calculate the rotation angle required to fit the label within the tick width
  var deg = (90 - Math.acos(Math.cos((tickWidth - 10) / maxWidth)) * (180 / Math.PI)) * -1;
  this.adjustedXaXisTickLabelHeight = Math.sqrt(Math.pow(maxWidth, 2) - Math.pow(tickWidth, 2)) + 30; // Pathagorean Theorum + padding
  labels.each(function () {
    var text = Object(__WEBPACK_IMPORTED_MODULE_2_d3_selection__["select"])(this);
    text.attr('transform', 'rotate(' + deg + ')').attr('dx', (text.node().getComputedTextLength() + 10) / -2).attr('dy', 0);
  });
}

function unadjustLabels(labels, width, _ref2) {
  var maxWidth = _ref2.maxWidth;

  var label = this.chartConfig.xAxis.ticks.label;
  labels.attr('dy', this.optionHelper(label.adjustY)).attr('dx', this.optionHelper(label.adjustX)).attr('transform', '');
  this.adjustedXaXisTickLabelHeight = null;
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = callYAxis;
/* harmony export (immutable) */ __webpack_exports__["b"] = addYAxis;
/* harmony export (immutable) */ __webpack_exports__["h"] = formatYAxisLine;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatYAxisTicks;
/* harmony export (immutable) */ __webpack_exports__["a"] = _addYAxisLabelInner;
/* harmony export (immutable) */ __webpack_exports__["d"] = addYAxisLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = callYAxisGridlines;
/* harmony export (immutable) */ __webpack_exports__["c"] = addYAxisGridLines;
/* harmony export (immutable) */ __webpack_exports__["e"] = addYAxisPlotlines;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3_axis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(0);







function callYAxis() {
  var ticksConfig = this.chartConfig.yAxis.ticks;
  var labelConfig = ticksConfig.label;
  var axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["axisLeft"])(this.y).ticks(this.optionHelperCall(ticksConfig.count)).tickFormat(this.optionHelper(labelConfig.format));
  if (ticksConfig.values) {
    axis.tickValues(this.optionHelperCall(ticksConfig.values));
  }
  this.yAxisApi = axis;
  return axis;
}

function addYAxis() {
  var yAxisOptions = this.chartConfig.yAxis;

  if (!this.yAxis) {
    this.yAxis = this.layers[yAxisOptions.zIndex].append('g').attr('class', __WEBPACK_IMPORTED_MODULE_0_classnames___default()('axis', 'axis--y', this.optionHelperCall(yAxisOptions.className))).call(this.callYAxis());

    // Set font-family on tick labels
    this.yAxis.selectAll('text').attr('font-family', __WEBPACK_IMPORTED_MODULE_2__constants__["FONT_FAMILY"]);
  } else {
    this.layers[yAxisOptions.zIndex].select('.axis--y').transition(this.transition).call(this.callYAxis());
  }

  if (yAxisOptions.line) {
    this.formatYAxisLine();
  }
  if (yAxisOptions.ticks) {
    this.formatYAxisTicks();
  }
  if (yAxisOptions.label && (yAxisOptions.label.enabled !== false || yAxisOptions.label.text)) {
    this.addYAxisLabel();
  }
  if (yAxisOptions.gridLines && yAxisOptions.gridLines.enabled !== false) {
    this.addYAxisGridLines();
  }

  if (yAxisOptions.plotlines) {
    this.addYAxisPlotlines();
  }
}

function formatYAxisLine() {
  var lineConfig = this.chartConfig.yAxis.line;
  var axisLine = this.yAxis.select('.domain');
  axisLine.attr('class', this.optionHelperCall(lineConfig.className)).attr('stroke', this.colorHelper(lineConfig.color)).attr('stroke-width', this.optionHelper(lineConfig.width));
}

function formatYAxisTicks() {
  var tickOptions = this.chartConfig.yAxis.ticks;
  var labelOptions = tickOptions.label;
  var ticks = this.yAxis.selectAll('.tick');
  ticks.selectAll('line').attr('class', this.optionHelper(tickOptions.className)).attr('stroke', this.colorHelper(tickOptions.color));
  var labels = ticks.selectAll('text').attr('class', this.optionHelper(labelOptions.className)).attr('font-family', __WEBPACK_IMPORTED_MODULE_2__constants__["FONT_FAMILY"]).attr('dx', labelOptions.adjustX).attr('dy', labelOptions.adjustY);
  this.styleLabels(labels, labelOptions);
}

function _addYAxisLabelInner(labelConfig) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var label = this.yAxis.select('.axis--label--y--' + index);
  if (label.empty()) {
    label = this.yAxis.append('text').attr('class', 'axis--label axis--label--y axis--label--y--' + index);
  }
  label.attr('transform', 'rotate(-90)')
  // Ajust X is dy because label is rotated
  .attr('dy', this.optionHelper(labelConfig.adjustX, [label]))
  // Ajust Y is dx because label is rotated
  .attr('dx', this.optionHelper(labelConfig.adjustY, [label])).attr('text-anchor', this.optionHelper(labelConfig.anchor, [label])).attr('font-family', __WEBPACK_IMPORTED_MODULE_2__constants__["FONT_FAMILY"]).attr('class', this.optionHelper(labelConfig.className)).text(labelConfig.text);

  this.styleLabels(label, labelConfig);
  // Apply to x because label is rotated
  label.attr('x', this.optionHelper(labelConfig.y, [label]));
  return label;
}

function addYAxisLabel() {
  var _this = this;

  var labelConfig = this.chartConfig.yAxis.label;
  var yAxisLabels = [];
  if (Object(__WEBPACK_IMPORTED_MODULE_4_utils__["isArray"])(labelConfig)) {
    labelConfig.forEach(function (l, i) {
      yAxisLabels.push(_this._addYAxisLabelInner(l, i));
    });
  } else {
    yAxisLabels.push(this._addYAxisLabelInner(labelConfig));
  }
  this.yAxisLabels = yAxisLabels;
}

function callYAxisGridlines() {
  var ticks = this.chartConfig.yAxis.ticks;
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["axisLeft"])().scale(this.y).ticks(this.optionHelperCall(ticks.count)).tickSize(-this.chartWidth, 0, 0).tickFormat('');
}

function addYAxisGridLines() {
  var yAxisOptions = this.chartConfig.yAxis;
  var gridLinesConfig = yAxisOptions.gridLines;
  var zIndex = yAxisOptions.zIndex > 0 ? yAxisOptions.zIndex - 1 : yAxisOptions.zIndex;
  if (!this.gridY) {
    this.gridY = this.layers[zIndex].append('g').attr('class', 'grid grid--y').call(this.callYAxisGridlines());
    // Hide stroke that wraps the whole grid
    this.gridY.select('.domain').attr('stroke', 'transparent');
  } else {
    this.layers[zIndex].selectAll('.grid--y').transition(this.transition).call(this.callYAxisGridlines());
  }
  this.gridY.selectAll('.tick').selectAll('line').attr('stroke', this.colorHelper(gridLinesConfig.color)).attr('class', this.optionHelper(gridLinesConfig.className));
}

function addYAxisPlotlines() {
  var _this2 = this;

  var configsByZIndex = {};
  (this.chartConfig.yAxis.plotlines.constructor === Array ? this.chartConfig.yAxis.plotlines : [this.chartConfig.yAxis.plotlines]).forEach(function (p) {
    // Apply default configs
    var pConfig = Object(__WEBPACK_IMPORTED_MODULE_3__chart_config__["b" /* defaultsDeep */])(p, __WEBPACK_IMPORTED_MODULE_3__chart_config__["c" /* plotlineDefaults */]);
    // Create z-index lookup
    if (!configsByZIndex[pConfig.zIndex]) {
      configsByZIndex[pConfig.zIndex] = [];
    }
    // Add to z-index lookup
    configsByZIndex[pConfig.zIndex].push(pConfig);
    // Return config w/ defaults applied
    return pConfig;
  });

  var _loop = function _loop(zIndex) {
    var plotlines = _this2.layers[zIndex].selectAll('.plotline').data(configsByZIndex[zIndex]);

    plotlines.exit().remove();

    var enterPlotlines = plotlines.enter().append('line').attr('class', function (d) {
      return __WEBPACK_IMPORTED_MODULE_0_classnames___default()('plotline-' + d.id, __WEBPACK_IMPORTED_MODULE_2__constants__["PLOTLINE_CLASSNAME"]);
    }).attr('x1', 0).attr('x2', 0).attr('y1', function (d) {
      return _this2.y(d.value);
    }).attr('y2', function (d) {
      return _this2.y(d.value);
    }).attr('stroke', function (d) {
      return _this2.colorHelper(d.color);
    }).attr('stroke-dasharray', function (d) {
      return __WEBPACK_IMPORTED_MODULE_2__constants__["PLOTLINE_DASH_STYLES"][_this2.optionHelper(d.dashStyle)](d);
    }).attr('stroke-width', function (d) {
      return _this2.optionHelper(d.width || 1);
    });

    plotlines = plotlines.merge(enterPlotlines);

    plotlines.transition().delay(function (d) {
      return _this2.plotlines[d.id] ? 0 : 500;
    }).duration(500).attr('y1', function (d) {
      return _this2.y(d.value);
    }).attr('y2', function (d) {
      return _this2.y(d.value);
    }).attr('x2', _this2.chartWidth);

    var labels = _this2.layers[zIndex].selectAll('.plotline-label').data(configsByZIndex[zIndex].filter(function (c) {
      return c.label.enabled;
    }));

    var enterLabels = labels.enter().append('text').attr('class', 'plotline-label').attr('x', _this2.chartWidth).attr('y', function (d) {
      return _this2.y(d.value);
    }).attr('dx', function (d) {
      return _this2.optionHelperCall(d.label.adjustX);
    }).attr('dy', function (d) {
      return _this2.optionHelperCall(d.label.adjustY);
    }).attr('font-size', function (d) {
      return _this2.optionHelperCall(d.label.fontSize);
    }).attr('opacity', 0);

    var chartWidth = _this2.chartWidth;
    labels = labels.merge(enterLabels).text(function (d) {
      return d.label.format(d);
    }).each(function (d) {
      this.setAttribute('x', chartWidth - this.getComputedTextLength());
    }).transition().duration(500).attr('opacity', 1).attr('y', function (d) {
      return _this2.y(d.value);
    });

    configsByZIndex[zIndex].forEach(function (p) {
      _this2.plotlines[p.id] = _this2.chart.selectAll('.plotline-' + p.id);
    });
  };

  for (var zIndex in configsByZIndex) {
    _loop(zIndex);
  }
}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = require("d3-ease");

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(41);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartTooltipShared.css-module.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartTooltipShared.css-module.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ":root {\n  /* Colors */\n\n  /* Other */\n}\n/* Export colors for use in JavaScript */\n.ChartTooltipShared-css-module__Tooltip {\n  position: absolute;\n  padding: 15px;\n  background: rgba(255, 255, 255, .84);\n  border: 1px solid #EAEAEA;\n  pointer-events: none;\n  min-width: 100px;\n  -webkit-transition: -webkit-transform 0.3s;\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n  text-align: left;\n  border-radius: 4px;\n  padding: 20px;\n  font-size: 14px;\n  font-weight: 100;\n  line-height: 19.2px;\n  line-height: 1.2rem;\n  text-align: left;\n  -webkit-box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, .1);\n          box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, .1);\n  font-family: Avenir W01, Avenir, Helvetica, sans-serif;\n  -webkit-transition: top 0.2s , left 0.2s, -webkit-transform 0.2s;\n  transition: top 0.2s , left 0.2s, -webkit-transform 0.2s;\n  transition: top 0.2s , left 0.2s, transform 0.2s;\n  transition: top 0.2s , left 0.2s, transform 0.2s , -webkit-transform 0.2s;\n}\n.ChartTooltipShared-css-module__TooltipArrow {\n  position: absolute;\n  top: 50%;\n  font-size: 16px;\n  width: 10px;\n  -webkit-transform: scaleX(1.5);\n  border: none;\n  line-height: 8px;\n  color: white;\n  margin: 0;\n  text-shadow: #EAEAEA 0px 3px 0px\n}\n.ChartTooltipShared-css-module__TooltipArrow::after {\n  content: \"\\25BC\";\n}\n.ChartTooltipShared-css-module__TooltipX {\n  font-size: 12px;\n  white-space: nowrap;\n}\n.ChartTooltipShared-css-module__TooltipY {\n  font-size: 16px;\n  font-weight: 900;\n  padding-top: 10px;\n  white-space: nowrap;\n}\n.ChartTooltipShared-css-module__TooltipAttachRight {\n  -webkit-transform: translate(15px, -50%);\n          transform: translate(15px, -50%);\n}\n.ChartTooltipShared-css-module__TooltipAttachRight .ChartTooltipShared-css-module__TooltipArrow {\n    left: -1px;\n    -webkit-transform: translate(-100%, -50%) rotate(90deg);\n            transform: translate(-100%, -50%) rotate(90deg);\n  }\n.ChartTooltipShared-css-module__TooltipAttachLeft {\n  -webkit-transform: translate(calc(-100% - 15px), -50%);\n          transform: translate(calc(-100% - 15px), -50%);\n}\n.ChartTooltipShared-css-module__TooltipAttachLeft .ChartTooltipShared-css-module__TooltipArrow {\n    right: -1px;\n    -webkit-transform: translate(100%, -50%) rotate(270deg);\n            transform: translate(100%, -50%) rotate(270deg);\n  }\n", ""]);

// exports
exports.locals = {
	"colorText": "#4a4a4a",
	"colorTextLight": "#939AA3",
	"colorOrange": "#FEB913",
	"colorBlue": "#28B7D3",
	"colorGreen": "#87d191",
	"colorYellow": "#fbe6be",
	"colorChangePos": "#8db258",
	"colorChangeNeg": "#bf4830",
	"colorChartLoading": "#DDD",
	"colorBorder": "#EAEAEA",
	"colorBlueDark": "#2D3B4C",
	"Tooltip": "ChartTooltipShared-css-module__Tooltip",
	"TooltipArrow": "ChartTooltipShared-css-module__TooltipArrow",
	"TooltipX": "ChartTooltipShared-css-module__TooltipX",
	"TooltipY": "ChartTooltipShared-css-module__TooltipY",
	"TooltipAttachRight": "ChartTooltipShared-css-module__TooltipAttachRight",
	"TooltipAttachLeft": "ChartTooltipShared-css-module__TooltipAttachLeft"
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartTooltipSingular.css-module.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartTooltipSingular.css-module.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".ChartTooltipSingular-css-module__Tooltip {\n  pointer-events: none;\n  opacity: 0.9;\n  border: 3px solid #FFFFFF;\n  background-color: rgba(255, 255, 255, .84);\n  border-radius: 5px;\n  font-size: .75rem;\n  line-height: 1rem;\n  text-align: center;\n  -webkit-box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, .1);\n          box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, .1);\n  z-index: 1;\n  position: absolute;\n  font-family: Avenir W01, Avenir, Helvetica, sans-serif \n}\n.ChartTooltipSingular-css-module__Tooltip .ChartTooltipSingular-css-module__TooltipContent {\n  padding: 15px 25px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; \n}\n.ChartTooltipSingular-css-module__Tooltip .ChartTooltipSingular-css-module__InfoRow {\n  font-weight: bold; \n}\n.ChartTooltipSingular-css-module__Tooltip .ChartTooltipSingular-css-module__TooltipArrow {\n  border-style: solid;\n  border-width: 10px 13px 0 13px;\n  border-color: white transparent transparent transparent;\n  position: absolute;\n  bottom: -10px \n}\n.ChartTooltipSingular-css-module__Tooltip .ChartTooltipSingular-css-module__TooltipArrow::after {\n  content: ' '; \n}\n", ""]);

// exports
exports.locals = {
	"Tooltip": "ChartTooltipSingular-css-module__Tooltip",
	"TooltipContent": "ChartTooltipSingular-css-module__TooltipContent",
	"InfoRow": "ChartTooltipSingular-css-module__InfoRow",
	"TooltipArrow": "ChartTooltipSingular-css-module__TooltipArrow"
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartLegendVertical.css-module.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartLegendVertical.css-module.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".ChartLegendVertical-css-module__Component {\n  width: 173px;\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 20px;\n  font-family: Avenir W01, Avenir, Helvetica, sans-serif;\n}\n\n.ChartLegendVertical-css-module__Title {\n  font-size: 14px;\n  font-weight: 900;\n  line-height: 19px;\n  margin: 0px;\n}\n\n.ChartLegendVertical-css-module__Series {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 10px 0;\n}\n\n.ChartLegendVertical-css-module__SeriesMarker {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  margin-right: 11px;\n  border-radius: 22px;\n  vertical-align: top;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.ChartLegendVertical-css-module__SeriesLabel {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 25px;\n  vertical-align: top;\n}\n\n@media (max-width: 700px) {\n  .ChartLegendVertical-css-module__Component {\n    width: 100%;\n    display: block;\n  }\n  .ChartLegendVertical-css-module__Title {\n    text-align: center;\n    padding: 15px 0;\n  }\n  .ChartLegendVertical-css-module__Items {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n  .ChartLegendVertical-css-module__SeriesMarker {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .ChartLegendVertical-css-module__Series {\n    width: auto;\n    min-width: 80px;\n  }\n  .ChartLegendVertical-css-module__SeriesLabel {\n    text-align: center;\n    display: block;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"Component": "ChartLegendVertical-css-module__Component",
	"Title": "ChartLegendVertical-css-module__Title",
	"Series": "ChartLegendVertical-css-module__Series",
	"SeriesMarker": "ChartLegendVertical-css-module__SeriesMarker",
	"SeriesLabel": "ChartLegendVertical-css-module__SeriesLabel",
	"Items": "ChartLegendVertical-css-module__Items"
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./Chart.css-module.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./Chart.css-module.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".Chart-css-module__Component {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  font-family: Avenir W01, Avenir, Helvetica, sans-serif;\n}\n.Chart-css-module__ChartContainer {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.Chart-css-module__legend-vertical {\n  width: calc(100% - 173px);\n  display: inline-block;\n}\n.Chart-css-module__Chart {\n  opacity: 1;\n  -webkit-transition: opacity 0.5s;\n  transition: opacity 0.5s;\n}\n@media (max-width: 700px) {\n  .Chart-css-module__ChartContainer {\n    width: 100%;\n    display: block;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"Component": "Chart-css-module__Component",
	"ChartContainer": "Chart-css-module__ChartContainer",
	"legend-vertical": "Chart-css-module__legend-vertical",
	"Chart": "Chart-css-module__Chart"
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_palette__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css__);







var LegendItem = function LegendItem(_ref) {
  var series = _ref.series;

  if (series.legend) {
    var _series$legend = series.legend,
        _series$legend$label = _series$legend.label,
        label = _series$legend$label === undefined ? '' : _series$legend$label,
        _series$legend$color = _series$legend.color,
        color = _series$legend$color === undefined ? series.color || series.fill || __WEBPACK_IMPORTED_MODULE_3_palette__["textDark"] : _series$legend$color,
        _series$legend$marker = _series$legend.marker,
        marker = _series$legend$marker === undefined ? {} : _series$legend$marker;


    var stroke = series.legend.stroke || series.stroke;

    var markerStyle = {
      borderRadius: (marker.width || 20) + 'px',
      width: (marker.width || 20) + 'px',
      height: (marker.width || 20) + 'px',
      background: color,
      border: stroke ? (stroke.width || 1) + 'px solid ' + (stroke.color || color) : 'none'
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default.a.Series, title: label || '' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default.a.SeriesMarker, style: markerStyle }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default.a.SeriesLabel },
        label || ''
      )
    );
  }
  return null;
};

var ChartLegendHorizontal = function ChartLegendHorizontal(_ref2) {
  var series = _ref2.series,
      className = _ref2.className,
      legendConfig = _ref2.legendConfig;
  var title = legendConfig.title;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default.a.Component, className) },
    title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h5',
      { className: __WEBPACK_IMPORTED_MODULE_4_css_modules_ChartLegendHorizontal_css_module_css___default.a.Title },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      Object(__WEBPACK_IMPORTED_MODULE_2_utils__["isObject"])(series) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendItem, { series: series }) : series.map(function (s, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendItem, { key: 'legend-item--' + (s.id || s.label || i), series: s });
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ChartLegendHorizontal);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartLegendHorizontal.css-module.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!./ChartLegendHorizontal.css-module.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".ChartLegendHorizontal-css-module__Component {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: block;\n  vertical-align: top;\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-family: Avenir W01, Avenir, Helvetica, sans-serif;\n}\n\n.ChartLegendHorizontal-css-module__Title {\n  font-size: 14px;\n  font-weight: 900;\n  line-height: 19px;\n  margin: 0px;\n}\n\n.ChartLegendHorizontal-css-module__Series {\n  padding: 0 10px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center\n}\n\n.ChartLegendHorizontal-css-module__Series:first-child {\n  padding-left: 0px;\n}\n\n.ChartLegendHorizontal-css-module__Series:last-child {\n  padding-right: 0px;\n}\n\n.ChartLegendHorizontal-css-module__SeriesMarker {\n  display: inline-block;\n  margin-right: 11px;\n  vertical-align: top;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.ChartLegendHorizontal-css-module__SeriesLabel {\n  font-size: 11px;\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"Component": "ChartLegendHorizontal-css-module__Component",
	"Title": "ChartLegendHorizontal-css-module__Title",
	"Series": "ChartLegendHorizontal-css-module__Series",
	"SeriesMarker": "ChartLegendHorizontal-css-module__SeriesMarker",
	"SeriesLabel": "ChartLegendHorizontal-css-module__SeriesLabel"
};

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map